import { memo, ComponentType } from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { IconProps } from "./types";

// antd Icon 的轻量替代:接受 component prop 渲染 SVG,透传 className / style
// 用法跟 @ant-design/icons 的 Icon 基类一致:<Icon component={() => <svg>...</svg>} />
const Icon: React.FC<IconProps & { component?: ComponentType }> = ({
  component: SvgComponent,
  className,
  style,
}) => {
  if (!SvgComponent) return null;
  return (
    <span
      className={classNames(styles.icon, className)}
      style={style}
      role="img"
      aria-hidden="true"
    >
      <SvgComponent />
    </span>
  );
};
export default {
  Coupon: memo<IconProps>(({ className, style }) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="23"
        height="19"
        viewBox="0 0 23 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Coupon Icon"
      >
        <path
          d="M0 12.2487C1.56467 12.2487 2.83333 10.9713 2.83333 9.396C2.83333 7.83467 1.58667 6.56667 0.0413332 6.544V2C0.0413332 1.46957 0.252047 0.96086 0.62712 0.585787C1.00219 0.210714 1.5109 0 2.04133 0H20.708C21.2384 0 21.7471 0.210714 22.1222 0.585787C22.4973 0.96086 22.708 1.46957 22.708 2L22.7073 6.54533L22.612 6.54733C21.1113 6.61933 19.916 7.86733 19.916 9.396C19.916 10.9573 21.162 12.226 22.7073 12.2487V16.6667C22.7073 17.1971 22.4966 17.7058 22.1215 18.0809C21.7465 18.456 21.2378 18.6667 20.7073 18.6667H2.04133C1.5109 18.6667 1.00219 18.456 0.62712 18.0809C0.252047 17.7058 0.0413332 17.1971 0.0413332 16.6667V12.248L0 12.2487ZM7.37467 12V14.6667H9.5V12H7.37467ZM7.37467 8V10.6667H9.5V8H7.37467ZM7.37467 4V6.66667H9.5V4H7.37467Z"
          fill="#346EDB"
        />
      </svg>
    );
  }),
  Telegram: memo<IconProps>(({ className, style }) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1778"
        width="48"
        height="48"
        role="img"
        aria-label="Telegram Icon"
      >
        <path
          d="M1021.10368 160l-155.2 728c-11.2 51.2-41.6 64-84.8 40L545.90368 756.8 432.30368 865.6c-12.8 12.8-22.4 22.4-48 22.4l17.6-240 436.8-393.6c19.2-17.6-4.8-25.6-28.8-9.6L269.10368 584 37.10368 512c-51.2-16-51.2-51.2 11.2-75.2L955.50368 86.4c43.2-14.4 80 9.6 65.6 73.6z"
          p-id="1779"
        ></path>
      </svg>
    );
  }),
  SoundOn: memo<IconProps>(({ className, style }) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Sound On Icon"
      >
        <path
          d="M9.383 3.076a1 1 0 0 1 1.09.217l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L11.586 8H5a1 1 0 1 1 0-2h6.586L9.383 4.414a1 1 0 0 1 0-1.414z"
          fill="currentColor"
        />
        <path
          d="M15.536 8.464a.5.5 0 0 1 .707 0 3 3 0 0 1 0 4.243.5.5 0 0 1-.707-.707 2 2 0 0 0 0-2.829.5.5 0 0 1 0-.707z"
          fill="currentColor"
        />
        <path
          d="M13.828 10.172a.5.5 0 0 1 .707 0 1.5 1.5 0 0 1 0 2.121.5.5 0 0 1-.707-.707.5.5 0 0 0 0-.707.5.5 0 0 1 0-.707z"
          fill="currentColor"
        />
      </svg>
    );
  }),
  SoundOff: memo<IconProps>(({ className, style }) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Sound Off Icon"
      >
        <path
          d="M9.383 3.076a1 1 0 0 1 1.09.217l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L11.586 8H5a1 1 0 1 1 0-2h6.586L9.383 4.414a1 1 0 0 1 0-1.414z"
          fill="currentColor"
        />
        <path
          d="M15.536 8.464a.5.5 0 0 1 .707 0 3 3 0 0 1 0 4.243.5.5 0 0 1-.707-.707 2 2 0 0 0 0-2.829.5.5 0 0 1 0-.707z"
          fill="currentColor"
        />
        <path
          d="M13.828 10.172a.5.5 0 0 1 .707 0 1.5 1.5 0 0 1 0 2.121.5.5 0 0 1-.707-.707.5.5 0 0 0 0-.707.5.5 0 0 1 0-.707z"
          fill="currentColor"
        />
        <path
          d="M2.5 2.5l15 15"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }),
  Recharge: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.20055 7.25003C10.5435 7.25003 12.9786 6.73484 14.4406 5.75373V7.54183H15.7953V3.62507C15.7953 1.27052 11.8823 0 8.20055 0C4.51883 0 0.606079 1.27052 0.606079 3.6252V14.3104C0.606079 16.6649 4.51901 17.9354 8.20069 17.9354V16.5808C4.33449 16.5808 1.96071 15.2584 1.96071 14.3104V11.0966C3.42284 12.0775 5.85787 12.5929 8.20069 12.5929V11.2382C4.33449 11.2382 1.96071 9.91582 1.96071 8.96768V5.75387C3.42259 6.73484 5.85752 7.25003 8.20055 7.25003ZM8.20055 1.35449C12.0669 1.35449 14.4406 2.67706 14.4406 3.62507C14.4406 4.57314 12.0669 5.89557 8.20055 5.89557C4.33445 5.89557 1.96057 4.57314 1.96057 3.62507C1.96061 2.67703 4.33449 1.35449 8.20055 1.35449ZM14.2715 7.99041C10.9086 7.99041 9.14897 9.28424 9.14897 10.5621V17.4284C9.14897 18.7063 10.9086 20 14.2715 20C17.6091 20 19.3665 18.7255 19.3925 17.4569H19.3939V10.5619C19.3938 9.2841 17.6344 7.99041 14.2715 7.99041ZM14.2715 9.34504C16.7573 9.34504 18.0392 10.198 18.0392 10.5621C18.0392 10.9262 16.7573 11.7792 14.2715 11.7792C11.7854 11.7792 10.5035 10.9262 10.5035 10.5621C10.5035 10.198 11.7856 9.34504 14.2715 9.34504ZM14.2715 18.6451C11.7854 18.6451 10.5035 17.7921 10.5035 17.4281V15.789C11.3631 16.2557 12.6245 16.5665 14.2715 16.5665C15.9184 16.5665 17.1798 16.2556 18.0392 15.789V17.4281C18.0392 17.7921 16.7573 18.6451 14.2715 18.6451ZM14.2715 15.212C11.7854 15.212 10.5035 14.3591 10.5035 13.9951V12.3559C11.3631 12.8226 12.6245 13.1335 14.2715 13.1335C15.9184 13.1335 17.1798 12.8229 18.0392 12.3561V13.9953C18.0392 14.3591 16.7573 15.212 14.2715 15.212Z"
          fill="#FFFFFF"
        />
      </svg>
    );
  },
  Withdraw: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9373 10.5453V13.0822C17.9353 13.8389 17.6333 14.5639 17.0976 15.0983C16.5618 15.6326 15.836 15.9327 15.0793 15.9327H3.56252C2.80583 15.9327 2.08002 15.6326 1.54425 15.0983C1.00848 14.5639 0.706486 13.8389 0.704486 13.0822V9.99299C0.703865 9.96743 0.708442 9.942 0.717942 9.91825C0.727442 9.8945 0.741665 9.87294 0.75975 9.85485C0.777835 9.83677 0.799404 9.82254 0.82315 9.81304C0.846896 9.80354 0.872324 9.79897 0.897892 9.79959H1.78635C1.81192 9.79897 1.83735 9.80354 1.8611 9.81304C1.88484 9.82254 1.90641 9.83677 1.9245 9.85485C1.94258 9.87294 1.9568 9.8945 1.9663 9.91825C1.9758 9.942 1.98038 9.96743 1.97976 9.99299V12.6395C1.97976 13.9926 2.63931 14.6506 3.99618 14.6506H14.6147C15.9715 14.6506 16.6318 13.9926 16.6318 12.6395V10.6488H13.1996C12.8258 10.649 12.4673 10.5009 12.2025 10.237C11.9378 9.97315 11.7886 9.61504 11.7876 9.24128V7.19162C11.7876 6.41497 12.4207 5.78338 13.1996 5.78338H16.6318V3.36051C16.6318 2.00666 15.9715 1.34863 14.6147 1.34863H3.98635C2.62873 1.34863 1.96918 2.00666 1.96918 3.36051V6.007C1.9697 6.03251 1.96505 6.05786 1.9555 6.08151C1.94595 6.10517 1.93172 6.12665 1.91364 6.14465C1.89557 6.16266 1.87403 6.17681 1.85034 6.18626C1.82664 6.19572 1.80128 6.20027 1.77578 6.19966H0.887316C0.861875 6.20017 0.836593 6.19554 0.812987 6.18604C0.789381 6.17654 0.767938 6.16237 0.749946 6.14437C0.731953 6.12638 0.717781 6.10494 0.708282 6.08133C0.698782 6.05773 0.69415 6.03245 0.694664 6.007V2.91703C0.696665 2.16041 0.998686 1.43548 1.53448 0.901245C2.07027 0.367012 2.79608 0.0671039 3.5527 0.0673066H15.0687C15.8254 0.0671034 16.5513 0.366988 17.0872 0.901199C17.6231 1.43541 17.9253 2.16034 17.9275 2.91703V5.88915C18.4518 6.10975 18.8039 6.61744 18.8258 7.18633V9.24128C18.8258 9.81016 18.4692 10.333 17.9373 10.5453ZM17.7469 7.56257C17.7469 7.14629 17.4024 6.80783 16.9801 6.80783H13.6333C13.2102 6.80783 12.8657 7.14629 12.8657 7.56257V8.7774C12.8657 9.19368 13.2102 9.53214 13.6333 9.53214H16.9801C17.4024 9.53214 17.7469 9.18915 17.7469 8.76758V7.56257ZM14.0571 8.97005C13.8327 8.97005 13.6091 8.88166 13.461 8.73283C13.3821 8.65769 13.3193 8.56718 13.2767 8.46687C13.2341 8.36656 13.2125 8.25858 13.2132 8.14959C13.2132 7.90632 13.2978 7.7046 13.4648 7.55124C13.6114 7.40543 13.8289 7.31779 14.0465 7.31779C14.2611 7.31779 14.4802 7.40694 14.6486 7.56106C14.8065 7.70687 14.901 7.92672 14.901 8.14959C14.901 8.35659 14.8058 8.58022 14.6524 8.73358C14.4913 8.88522 14.2784 8.96978 14.0571 8.97005ZM0.746038 8.64293C0.728679 8.62131 0.716074 8.59628 0.709045 8.56946C0.702015 8.54264 0.700719 8.51464 0.705241 8.48729L0.704486 7.46964C0.703968 7.44414 0.708623 7.41879 0.718169 7.39513C0.727715 7.37148 0.741954 7.35 0.760028 7.33199C0.778102 7.31399 0.799636 7.29984 0.823331 7.29038C0.847025 7.28093 0.872389 7.27637 0.897892 7.27699H4.50689L4.32935 7.09416C4.29227 7.05681 4.27046 7.00697 4.26815 6.95439V5.40941C4.26815 5.33386 4.30971 5.26586 4.37694 5.23187L4.41094 5.21676H4.46156C4.54089 5.21676 4.58622 5.26209 4.60359 5.27946L7.1549 7.85419C7.19105 7.89224 7.21114 7.94276 7.211 7.99524C7.21086 8.04772 7.1905 8.09813 7.15414 8.13599L4.60359 10.71C4.56557 10.7476 4.515 10.7699 4.46156 10.7727L4.40414 10.7704L4.3777 10.7576C4.34461 10.7412 4.31678 10.7159 4.29741 10.6845C4.27804 10.6531 4.2679 10.6169 4.26815 10.58V9.03503C4.26815 8.95645 4.31273 8.91188 4.32935 8.89526L4.50689 8.71243H0.897892C0.869004 8.71287 0.840381 8.70686 0.81411 8.69484C0.78784 8.68281 0.764584 8.66508 0.746038 8.64293Z"
          fill="#FFFFFF"
        />
      </svg>
    );
  },
  Mailbox: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="25.729"
        height="18.378"
        viewBox="0 0 25.729 18.378"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="-0.335"
            y1="0.539"
            x2="1.207"
            y2="0.577"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#0a9dff"></stop>
            <stop offset="1" stopColor="#1a52ee"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1="0.5"
            y1="0"
            x2="0.5"
            y2="1"
            xlinkHref="#linear-gradient"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-3"
            x1="0.5"
            y1="0.891"
            x2="0.5"
            y2="0.229"
            xlinkHref="#linear-gradient"
          ></linearGradient>
        </defs>
        <g id="Massage" transform="translate(-10047 -925)">
          <path
            id="_24248"
            data-name="24248"
            d="M3.063,0h19.6a3.063,3.063,0,0,1,3.063,3.063V15.315a3.063,3.063,0,0,1-3.063,3.063H3.063A3.063,3.063,0,0,1,0,15.315V3.063A3.063,3.063,0,0,1,3.063,0Z"
            transform="translate(10047 925)"
            fill="url(#linear-gradient)"
          ></path>
          <path
            id="_24249"
            data-name="24249"
            d="M23.282,1.405a3.063,3.063,0,0,1,3.289,0l9.7,6.171a3.063,3.063,0,0,1-1.644,5.647H15.23a3.063,3.063,0,0,1-1.644-5.647Z"
            transform="translate(10034.938 930.154)"
            fill="url(#linear-gradient-2)"
          ></path>
          <path
            id="_24250"
            data-name="24250"
            d="M11.121.479a3.063,3.063,0,0,1,3.289,0l9.7,6.171A3.063,3.063,0,0,1,22.463,12.3H3.068A3.063,3.063,0,0,1,1.424,6.65Z"
            transform="translate(10072.629 937.297) rotate(180)"
            fill="url(#linear-gradient-3)"
          ></path>
        </g>
      </svg>
    );
  },
  TabIconGame: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 5.33337H2.76923C2.60602 5.33337 2.4495 5.39252 2.33409 5.49781C2.21868 5.60309 2.15385 5.74588 2.15385 5.89478C2.15385 6.04367 2.21868 6.18646 2.33409 6.29175C2.4495 6.39703 2.60602 6.45618 2.76923 6.45618H4V7.57898C4 7.6527 4.01592 7.72571 4.04684 7.79382C4.07777 7.86193 4.1231 7.92382 4.18024 7.97595C4.23739 8.02808 4.30523 8.06943 4.37989 8.09765C4.45455 8.12586 4.53457 8.14038 4.61538 8.14038C4.6962 8.14038 4.77622 8.12586 4.85088 8.09765C4.92554 8.06943 4.99338 8.02808 5.05053 7.97595C5.10767 7.92382 5.153 7.86193 5.18393 7.79382C5.21485 7.72571 5.23077 7.6527 5.23077 7.57898V6.45618H6.46154C6.62475 6.45618 6.78127 6.39703 6.89668 6.29175C7.01209 6.18646 7.07692 6.04367 7.07692 5.89478C7.07692 5.74588 7.01209 5.60309 6.89668 5.49781C6.78127 5.39252 6.62475 5.33337 6.46154 5.33337H5.23077V4.21057C5.23077 4.13685 5.21485 4.06385 5.18393 3.99573C5.153 3.92762 5.10767 3.86573 5.05053 3.8136C4.99338 3.76147 4.92554 3.72012 4.85088 3.6919C4.77622 3.66369 4.6962 3.64917 4.61538 3.64917C4.53457 3.64917 4.45455 3.66369 4.37989 3.6919C4.30523 3.72012 4.23739 3.76147 4.18024 3.8136C4.1231 3.86573 4.07777 3.92762 4.04684 3.99573C4.01592 4.06385 4 4.13685 4 4.21057V5.33337ZM13.0542 12.0075C12.8685 10.619 11.5718 9.54389 10 9.54389C8.42815 9.54389 7.13154 10.6191 6.94585 12.0075C6.32277 14.3843 5.09938 16 3.69231 16C1.65308 16 0 12.6068 0 8.42108C0 5.25253 0.947231 2.53816 2.29231 1.40595C3.23954 0.537604 4.55077 6.18106e-05 6 6.18106e-05H6.19338L6.194 0.000763511C6.32468 -0.00452667 6.45491 0.0179486 6.57444 0.0664172C6.69397 0.114886 6.79952 0.188023 6.88277 0.280061H6.88369C7.39877 0.857883 8.6 1.26322 10 1.26322C11.4 1.26322 12.6012 0.857883 13.1163 0.280061H13.1171C13.2003 0.188003 13.3059 0.114855 13.4255 0.0663854C13.545 0.017916 13.6753 -0.00454871 13.806 0.000763511L13.8066 6.18106e-05H14C15.4491 6.18106e-05 16.7605 0.537604 17.7077 1.40595C19.0528 2.53816 20 5.25253 20 8.42108C20 12.6068 18.3469 16 16.3077 16C14.9006 16 13.6772 14.3843 13.0542 12.0075ZM15.6923 7.57898C16.7118 7.57898 17.5385 6.82488 17.5385 5.89478C17.5385 4.96467 16.7118 4.21057 15.6923 4.21057C14.6728 4.21057 13.8462 4.96467 13.8462 5.89478C13.8462 6.82488 14.6728 7.57898 15.6923 7.57898Z"
          style={style}
        />
      </svg>
    );
  },
  TabIconBonus: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.1318 5.6841C12.8864 5.56485 12.8455 5.28661 13.0091 5.08787C13.1318 4.92887 13.2545 4.76987 13.3364 4.61088C14.1136 3.29916 14.0727 1.7887 13.1727 1.31172C12.9682 1.19247 12.7636 1.15272 12.5182 1.15272C12.2727 1.15272 12.0682 1.19247 11.8227 1.31172C11.7818 1.35146 11.7 1.35146 11.6591 1.35146C11.5364 1.35146 11.4136 1.31172 11.3318 1.19247C10.8 0.476987 9.94091 0 8.95909 0C7.97727 0 7.11818 0.476987 6.58636 1.19247C6.50455 1.31172 6.38182 1.35146 6.25909 1.35146C6.21818 1.35146 6.13636 1.35146 6.09545 1.31172C5.89091 1.15272 5.64545 1.11297 5.44091 1.11297C5.19545 1.11297 4.99091 1.15272 4.78636 1.27197C3.92727 1.74895 3.84545 3.25941 4.62273 4.57113C4.74545 4.73013 4.82727 4.92887 4.95 5.04812C5.11364 5.24686 5.07273 5.5251 4.82727 5.64435C1.96364 7.11506 0 10.0565 0 13.4351C0 15.1444 0.572727 16.7343 1.51364 18.046C1.96364 18.6423 2.7 19 3.47727 19H14.5227C15.3 19 16.0364 18.6423 16.4864 18.046C17.4273 16.7343 18 15.1444 18 13.4351C18 10.0565 16.0364 7.11506 13.1318 5.6841ZM9 16.2176C9 14.0314 7.15909 12.2427 4.90909 12.2427C7.15909 12.2427 9 10.454 9 8.26778C9 10.454 10.8409 12.2427 13.0909 12.2427C10.8409 12.2427 9 14.0314 9 16.2176Z"
          style={style}
        />
      </svg>
    );
  },
  TabIconShare: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="20"
        height="17"
        viewBox="0 0 20 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.81493 13.6388C4.94993 14.104 5.37321 14.4263 5.85759 14.4327C6.34197 14.4391 6.77359 14.128 6.9208 13.6665C7.66608 11.33 9.42687 9.64296 11.516 9.20237C11.5991 10.1257 12.133 10.8833 12.871 11.2746C13.4053 11.5578 14.0408 11.6425 14.6483 11.4726V15.4612C14.6483 16.3109 13.9595 16.9997 13.1098 16.9997H2.06026C1.21059 16.9997 0.52179 16.3109 0.52179 15.4612V4.41164C0.52179 3.56197 1.21059 2.87317 2.06027 2.87317H8.33918C5.93627 4.49173 4.375 7.41523 4.375 10.66C4.375 11.7419 4.54291 12.7014 4.81493 13.6388ZM10.9504 2.87317C7.8099 3.72638 5.47576 6.88282 5.47576 10.66C5.47576 10.9079 5.48562 11.1489 5.50451 11.3846C5.55884 12.0625 5.6879 12.6973 5.87209 13.332C6.066 12.7241 6.3229 12.149 6.63414 11.6174C7.71919 9.76394 9.46471 8.43774 11.5047 8.0827C11.8632 8.0203 12.2308 7.9879 12.6054 7.9879V8.94912C12.6054 10.109 13.7501 10.801 14.6483 10.2872V4.41165C14.6483 3.56197 13.9595 2.87317 13.1098 2.87317H10.9504Z"
          style={style}
        />
        <path
          d="M5.4751 10.6619C5.4751 11.6231 5.6232 12.4785 5.87142 13.3339C6.86015 10.2342 9.48632 7.98982 12.6048 7.98982V8.95104C12.6048 10.2027 13.9377 10.9095 14.8555 10.1441L19.2422 6.48608C19.966 5.88279 19.966 4.70321 19.2422 4.09992L14.8576 0.441879C13.9398 -0.323495 12.6069 0.38335 12.6069 1.63496V2.64796C8.66656 2.67722 5.4751 6.24522 5.4751 10.6619Z"
          style={style}
        />
      </svg>
    );
  },
  Game: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          style={style}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.35 0.649597C2.39528 0.649597 0 3.04487 0 5.9996C0 8.95432 2.39528 11.3496 5.35 11.3496H10.65C13.6047 11.3496 16 8.95432 16 5.9996C16 3.04487 13.6047 0.649597 10.65 0.649597H5.35ZM3.21545 5.46439H4.20007V4.48825C4.20007 4.42416 4.2128 4.36069 4.23754 4.30148C4.26228 4.24226 4.29855 4.18846 4.34426 4.14313C4.38998 4.09781 4.44425 4.06186 4.50398 4.03733C4.56371 4.01281 4.62772 4.00018 4.69238 4.00018C4.75703 4.00018 4.82104 4.01281 4.88077 4.03733C4.9405 4.06186 4.99477 4.09781 5.04049 4.14313C5.0862 4.18846 5.12247 4.24226 5.14721 4.30148C5.17195 4.36069 5.18468 4.42416 5.18468 4.48825V5.46439H6.1693C6.29987 5.46439 6.42509 5.51581 6.51741 5.60734C6.60974 5.69887 6.66161 5.82301 6.66161 5.95246C6.66161 6.0819 6.60974 6.20604 6.51741 6.29757C6.42509 6.3891 6.29987 6.44052 6.1693 6.44052H5.18468V7.41666C5.18468 7.48075 5.17195 7.54422 5.14721 7.60344C5.12247 7.66265 5.0862 7.71646 5.04049 7.76178C4.99477 7.8071 4.9405 7.84305 4.88077 7.86758C4.82104 7.8921 4.75703 7.90473 4.69238 7.90473C4.62772 7.90473 4.56371 7.8921 4.50398 7.86758C4.44425 7.84305 4.38998 7.8071 4.34426 7.76178C4.29855 7.71646 4.26228 7.66265 4.23754 7.60344C4.2128 7.54422 4.20007 7.48075 4.20007 7.41666V6.44052H3.21545C3.08488 6.44052 2.95966 6.3891 2.86734 6.29757C2.77501 6.20604 2.72314 6.0819 2.72314 5.95246C2.72314 5.82301 2.77501 5.69887 2.86734 5.60734C2.95966 5.51581 3.08488 5.46439 3.21545 5.46439ZM13.0308 5.95246C13.0308 6.76106 12.3695 7.41666 11.5539 7.41666C10.7383 7.41666 10.077 6.76106 10.077 5.95246C10.077 5.14385 10.7383 4.48825 11.5539 4.48825C12.3695 4.48825 13.0308 5.14385 13.0308 5.95246Z"
          fill="#617496"
        />
      </svg>
    );
  },
  Menu: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="30"
        height="25"
        viewBox="0 0 30 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.8984 2C29.8984 1.17157 29.2269 0.5 28.3984 0.5H2.27344C1.44501 0.5 0.773438 1.17157 0.773438 2C0.773438 2.82843 1.44501 3.5 2.27344 3.5H28.3984C29.2269 3.5 29.8984 2.82843 29.8984 2ZM29.8984 9C29.8984 8.17157 29.2269 7.5 28.3984 7.5H12.0234C11.195 7.5 10.5234 8.17157 10.5234 9C10.5234 9.82843 11.195 10.5 12.0234 10.5H28.3984C29.2269 10.5 29.8984 9.82843 29.8984 9ZM28.3984 14.5C29.2269 14.5 29.8984 15.1716 29.8984 16C29.8984 16.8284 29.2269 17.5 28.3984 17.5H12.0234C11.195 17.5 10.5234 16.8284 10.5234 16C10.5234 15.1716 11.195 14.5 12.0234 14.5H28.3984ZM29.8984 23C29.8984 22.1716 29.2269 21.5 28.3984 21.5H2.27344C1.44501 21.5 0.773438 22.1716 0.773438 23C0.773438 23.8284 1.44501 24.5 2.27344 24.5H28.3984C29.2269 24.5 29.8984 23.8284 29.8984 23ZM1.39844 11.7277C0.731771 12.1126 0.73177 13.0749 1.39844 13.4598L5.33594 15.7331C6.0026 16.118 6.83594 15.6369 6.83594 14.8671V10.3204C6.83594 9.55063 6.00261 9.06951 5.33594 9.45441L1.39844 11.7277Z"
          fill="#66727D"
        />
      </svg>
    );
  },
  Star: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.68381 1.15299C6.08232 0.590025 6.91768 0.590024 7.31619 1.15298L8.99349 3.52239C9.12037 3.70163 9.30272 3.83412 9.5124 3.8994L12.2842 4.76242C12.9427 4.96747 13.2008 5.76193 12.7886 6.31491L11.0535 8.6423C10.9222 8.81836 10.8525 9.03273 10.8553 9.25231L10.891 12.1551C10.8995 12.8448 10.2237 13.3358 9.57037 13.1146L6.8207 12.1836C6.6127 12.1132 6.3873 12.1132 6.1793 12.1836L3.42963 13.1146C2.77632 13.3358 2.10051 12.8448 2.109 12.1551L2.14475 9.25232C2.14745 9.03273 2.0778 8.81836 1.94654 8.6423L0.211412 6.31491C-0.200846 5.76193 0.0572906 4.96747 0.715847 4.76242L3.4876 3.8994C3.69728 3.83412 3.87963 3.70163 4.00651 3.52239L5.68381 1.15299Z"
          fill="#FDA45B"
        />
      </svg>
    );
  },
  Verified: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.2236 11.2394C5.12938 11.307 5.02136 11.3528 4.90731 11.3736C4.79326 11.3943 4.67602 11.3895 4.56404 11.3595C4.45207 11.3295 4.34814 11.2751 4.25975 11.2C4.17136 11.125 4.10071 11.0314 4.05288 10.9258C3.93792 10.6721 3.74638 10.4607 3.50514 10.3215C3.26391 10.1822 2.98512 10.122 2.70792 10.1494C2.59257 10.1607 2.47614 10.1463 2.36701 10.1073C2.25789 10.0682 2.15878 10.0054 2.07684 9.92347C1.99489 9.8415 1.93214 9.74238 1.89311 9.63324C1.85408 9.5241 1.83974 9.40767 1.85112 9.29232C1.87844 9.0151 1.81821 8.73628 1.67891 8.49505C1.53961 8.25381 1.32824 8.06228 1.07448 7.94736C0.968879 7.89954 0.875201 7.82888 0.800195 7.74049C0.725189 7.6521 0.670723 7.54818 0.64072 7.4362C0.610718 7.32422 0.605926 7.20699 0.62669 7.09294C0.647455 6.97889 0.693258 6.87086 0.7608 6.77664C0.923019 6.55026 1.01025 6.27875 1.01025 6.00024C1.01025 5.72174 0.923019 5.45023 0.7608 5.22384C0.693258 5.12963 0.647455 5.0216 0.62669 4.90755C0.605926 4.7935 0.610718 4.67626 0.64072 4.56429C0.670723 4.45231 0.725189 4.34838 0.800195 4.25999C0.875201 4.1716 0.968879 4.10095 1.07448 4.05312C1.32819 3.93817 1.53952 3.74662 1.67877 3.50539C1.81803 3.26416 1.87822 2.98536 1.85088 2.70816C1.83953 2.59281 1.85391 2.47638 1.89297 2.36726C1.93203 2.25813 1.9948 2.15903 2.07677 2.07708C2.15874 1.99513 2.25787 1.93239 2.367 1.89335C2.47614 1.85432 2.59257 1.83998 2.70792 1.85136C2.98514 1.87868 3.26396 1.81846 3.50519 1.67916C3.74643 1.53986 3.93796 1.32848 4.05288 1.07472C4.10071 0.969124 4.17136 0.875445 4.25975 0.800439C4.34814 0.725433 4.45207 0.670967 4.56404 0.640964C4.67602 0.610962 4.79326 0.60617 4.90731 0.626934C5.02136 0.647699 5.12938 0.693502 5.2236 0.761045C5.44998 0.923263 5.72149 1.0105 6 1.0105C6.2785 1.0105 6.55001 0.923263 6.7764 0.761045C6.87062 0.693502 6.97864 0.647699 7.09269 0.626934C7.20674 0.60617 7.32398 0.610962 7.43596 0.640964C7.54793 0.670967 7.65186 0.725433 7.74025 0.800439C7.82864 0.875445 7.89929 0.969124 7.94712 1.07472C8.06208 1.32844 8.25362 1.53976 8.49486 1.67902C8.73609 1.81827 9.01488 1.87846 9.29208 1.85112C9.40743 1.83978 9.52386 1.85415 9.63299 1.89321C9.74211 1.93227 9.84122 1.99505 9.92316 2.07702C10.0051 2.15899 10.0679 2.25811 10.1069 2.36725C10.1459 2.47638 10.1603 2.59282 10.1489 2.70816C10.1216 2.98539 10.1818 3.2642 10.3211 3.50544C10.4604 3.74667 10.6718 3.93821 10.9255 4.05312C11.0311 4.10095 11.1248 4.1716 11.1998 4.25999C11.2748 4.34838 11.3293 4.45231 11.3593 4.56429C11.3893 4.67626 11.3941 4.7935 11.3733 4.90755C11.3525 5.0216 11.3067 5.12963 11.2392 5.22384C11.077 5.45023 10.9897 5.72174 10.9897 6.00024C10.9897 6.27875 11.077 6.55026 11.2392 6.77664C11.3067 6.87086 11.3525 6.97889 11.3733 7.09294C11.3941 7.20699 11.3893 7.32422 11.3593 7.4362C11.3293 7.54818 11.2748 7.6521 11.1998 7.74049C11.1248 7.82888 11.0311 7.89954 10.9255 7.94736C10.6718 8.06232 10.4605 8.25387 10.3212 8.4951C10.182 8.73633 10.1218 9.01513 10.1491 9.29232C10.1605 9.40767 10.1461 9.5241 10.107 9.63323C10.068 9.74236 10.0052 9.84146 9.92323 9.92341C9.84126 10.0054 9.74213 10.0681 9.633 10.1071C9.52386 10.1462 9.40742 10.1605 9.29208 10.1491C9.01486 10.1218 8.73604 10.182 8.4948 10.3213C8.25357 10.4606 8.06204 10.672 7.94712 10.9258C7.89929 11.0314 7.82864 11.125 7.74025 11.2C7.65186 11.2751 7.54793 11.3295 7.43596 11.3595C7.32398 11.3895 7.20674 11.3943 7.09269 11.3736C6.97864 11.3528 6.87062 11.307 6.7764 11.2394C6.55001 11.0772 6.2785 10.99 6 10.99C5.72149 10.99 5.44998 11.0772 5.2236 11.2394V11.2394Z"
          fill="#FDD535"
        />
        <path
          d="M8.36136 4.34614C8.42659 4.28067 8.51449 4.2428 8.60687 4.24036C8.69925 4.23792 8.78903 4.2711 8.85763 4.33303C8.92622 4.39496 8.96837 4.4809 8.97535 4.57305C8.98233 4.6652 8.9536 4.7565 8.89512 4.82806L8.8704 4.85542L5.81568 7.91014C5.75268 7.97313 5.66856 8.01052 5.57959 8.01509C5.49062 8.01965 5.40311 7.99107 5.334 7.93486L5.30664 7.91014L3.6096 6.21334C3.54405 6.14815 3.50609 6.06024 3.50358 5.96783C3.50107 5.87542 3.53421 5.78559 3.59613 5.71695C3.65805 5.6483 3.744 5.60611 3.83618 5.59911C3.92836 5.59211 4.0197 5.62083 4.09128 5.67934L4.11864 5.70406L5.56104 7.14622L8.36136 4.34638V4.34614Z"
          fill="#303948"
        />
      </svg>
    );
  },
  LuckyWheel: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5589 8.14838L11 5.4278L10.4833 8.14202C9.92026 8.24325 9.38038 8.51107 8.94381 8.94553C7.8092 10.0823 7.8092 11.9213 8.94381 13.0559C10.0784 14.1905 11.9196 14.1905 13.0542 13.0559C14.1909 11.9191 14.1909 10.0801 13.0542 8.94553C12.6303 8.52164 12.1072 8.25382 11.5589 8.14835L11.5589 8.14838ZM17.5631 17.5627L13.4295 13.4292C12.9867 13.8721 12.4531 14.1673 11.89 14.3192L13.4042 19.9691C12.6302 20.1757 11.8225 20.2812 11 20.2812C10.1776 20.2812 9.37192 20.1736 8.59794 19.9691L10.1122 14.3192C9.54697 14.1694 9.0155 13.8721 8.57263 13.4292L4.43907 17.5627C3.2454 16.3691 2.444 14.9266 2.0391 13.4018L7.68477 11.8897C7.52872 11.3073 7.52872 10.6942 7.68477 10.1118L2.0391 8.59971C2.444 7.07494 3.24332 5.63241 4.43699 4.43876L8.57054 8.57231C9.01342 8.12944 9.54489 7.8342 10.1101 7.68234L8.59797 2.03245C9.37194 1.82789 10.1776 1.72034 11.0001 1.72034C11.8225 1.72034 12.6282 1.82789 13.4042 2.03245L11.89 7.68234C12.4531 7.83209 12.9867 8.12941 13.4296 8.57231L17.5631 4.43876C18.7336 5.60925 19.554 7.0391 19.9694 8.5976L14.3174 10.1118C14.4735 10.6942 14.4735 11.3073 14.3174 11.8897L19.9673 13.4039C19.5519 14.9624 18.7336 16.3923 17.5631 17.5627H17.5631ZM18.4573 3.54455C16.4643 1.5537 13.8176 0.457031 11 0.457031C8.18455 0.457031 5.53574 1.5537 3.54489 3.54455C1.55193 5.5354 0.455261 8.18426 0.455261 10.9997C0.455261 13.8173 1.55193 16.464 3.54489 18.4569C5.53574 20.4499 8.1846 21.5445 11 21.5445C13.8176 21.5445 16.4643 20.4478 18.4573 18.4569C20.4502 16.4661 21.5448 13.8172 21.5448 10.9997C21.5448 8.18421 20.4481 5.5354 18.4573 3.54455Z"
          fill="#F4EA2A"
        />
      </svg>
    );
  },
  WhatsApp: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 175.216 175.552"
      >
        <defs>
          <linearGradient
            id="b"
            x1="85.915"
            x2="86.535"
            y1="32.567"
            y2="137.092"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#57d163" />
            <stop offset="1" stopColor="#23b33a" />
          </linearGradient>
          <filter
            id="a"
            width="1.115"
            height="1.114"
            x="-.057"
            y="-.057"
            colorInterpolationFilters="sRGB"
          >
            <feGaussianBlur stdDeviation="3.531" />
          </filter>
        </defs>
        <path
          fill="#b3b3b3"
          d="m54.532 138.45 2.235 1.324c9.387 5.571 20.15 8.518 31.126 8.523h.023c33.707 0 61.139-27.426 61.153-61.135.006-16.335-6.349-31.696-17.895-43.251A60.75 60.75 0 0 0 87.94 25.983c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 0 0 9.349 32.535l1.455 2.312-6.179 22.558zm-40.811 23.544L24.16 123.88c-6.438-11.154-9.825-23.808-9.821-36.772.017-40.556 33.021-73.55 73.578-73.55 19.681.01 38.154 7.669 52.047 21.572s21.537 32.383 21.53 52.037c-.018 40.553-33.027 73.553-73.578 73.553h-.032c-12.313-.005-24.412-3.094-35.159-8.954zm0 0"
          filter="url(#a)"
        />
        <path
          fill="#fff"
          d="m12.966 161.238 10.439-38.114a73.42 73.42 0 0 1-9.821-36.772c.017-40.556 33.021-73.55 73.578-73.55 19.681.01 38.154 7.669 52.047 21.572s21.537 32.383 21.53 52.037c-.018 40.553-33.027 73.553-73.578 73.553h-.032c-12.313-.005-24.412-3.094-35.159-8.954z"
        />
        <path
          fill="url(#linearGradient1780)"
          d="M87.184 25.227c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 0 0 9.349 32.535l1.455 2.312-6.179 22.559 23.146-6.069 2.235 1.324c9.387 5.571 20.15 8.518 31.126 8.524h.023c33.707 0 61.14-27.426 61.153-61.135a60.75 60.75 0 0 0-17.895-43.251 60.75 60.75 0 0 0-43.235-17.929z"
        />
        <path
          fill="url(#b)"
          d="M87.184 25.227c-33.733 0-61.166 27.423-61.178 61.13a60.98 60.98 0 0 0 9.349 32.535l1.455 2.313-6.179 22.558 23.146-6.069 2.235 1.324c9.387 5.571 20.15 8.517 31.126 8.523h.023c33.707 0 61.14-27.426 61.153-61.135a60.75 60.75 0 0 0-17.895-43.251 60.75 60.75 0 0 0-43.235-17.928z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M68.772 55.603c-1.378-3.061-2.828-3.123-4.137-3.176l-3.524-.043c-1.226 0-3.218.46-4.902 2.3s-6.435 6.287-6.435 15.332 6.588 17.785 7.506 19.013 12.718 20.381 31.405 27.75c15.529 6.124 18.689 4.906 22.061 4.6s10.877-4.447 12.408-8.74 1.532-7.971 1.073-8.74-1.685-1.226-3.525-2.146-10.877-5.367-12.562-5.981-2.91-.919-4.137.921-4.746 5.979-5.819 7.206-2.144 1.381-3.984.462-7.76-2.861-14.784-9.124c-5.465-4.873-9.154-10.891-10.228-12.73s-.114-2.835.808-3.751c.825-.824 1.838-2.147 2.759-3.22s1.224-1.84 1.836-3.065.307-2.301-.153-3.22-4.032-10.011-5.666-13.647"
        />
      </svg>
    );
  },
  Customer: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        aria-hidden="true"
        viewBox="0 0 46 46"
        id="icon-customer"
      >
        <rect
          width="46"
          height="46"
          rx="20"
          fill="url(#icon-customer_a)"
        ></rect>
        <mask
          id="icon-customer_b"
          maskUnits="userSpaceOnUse"
          x="9"
          y="12"
          width="28"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.002 12.005H36.97v17.681H9.002v-17.68Z"
            fill="#fff"
          ></path>
        </mask>
        <g mask="url(#icon-customer_b)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 24.695c0-1.747.489-3.496 2.256-3.496a12.322 12.322 0 0 1 11.728-9.194A12.32 12.32 0 0 1 34.713 21.2c1.748.14 2.256 1.75 2.256 3.496 0 1.747-.49 3.496-2.256 3.635a1.295 1.295 0 0 1-1.33-1.748v-.123c.09-.579.136-1.163.139-1.749a10.73 10.73 0 0 0-10.489-11.047h-.049a10.731 10.731 0 0 0-10.488 11.032c.003.585.05 1.17.14 1.748.103.629 0 .123 0 .123a1.295 1.295 0 0 1-1.33 1.748C9.488 28.191 9 26.671 9 24.695Zm14.742 5.016-.033.005-.095.023.128-.028Zm-.068.021h.005a.687.687 0 0 0 .123-.033l-.07.02-.058.013Zm1.326-.34.037-.024a.849.849 0 0 0 .09-.073l-.082.064-.046.033Zm.078-.058-.058.028-.07.043c.042-.026.085-.048.128-.072Z"
            fill="#fff"
          ></path>
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.214 24.695a9.433 9.433 0 0 0-9.23-9.544 9.433 9.433 0 0 0-9.229 9.544 9.43 9.43 0 0 0 9.23 9.635 9.433 9.433 0 0 0 9.229-9.634Zm-3.564 3.548c-.353.495-.771.94-1.243 1.323-.808.659-1.727 1.172-2.741 1.434a6.707 6.707 0 0 1-3.696-.096 7.259 7.259 0 0 1-3.65-2.66c-.243-.342-.049-.822.268-1.025.36-.233.799-.05 1.025.268l.027.039a6.85 6.85 0 0 0 1.055 1.04l.018.015a6.426 6.426 0 0 0 1.117.671l.12.054.05.02a5.897 5.897 0 0 0 1.13.322l.129.022c.033 0 .07.01.103.013a6.05 6.05 0 0 0 1.299-.006 6.225 6.225 0 0 0 .245-.04 5.882 5.882 0 0 0 1.074-.315 10.307 10.307 0 0 0 .206-.093 6.467 6.467 0 0 0 1.095-.667l.02-.017.097-.078a6.759 6.759 0 0 0 .806-.789c.05-.058.097-.12.147-.18l.008-.011c.243-.342.64-.472 1.025-.269.333.178.493.705.266 1.025Z"
          fill="#fff"
        ></path>
        <defs>
          <linearGradient
            id="icon-customer_a"
            x1="11.36"
            y1="-4.348"
            x2="23"
            y2="46"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor"></stop>
            <stop offset=".938" stopColor="currentColor"></stop>
          </linearGradient>
        </defs>
      </svg>
    );
  },
  Selected: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 0L0 16H12C14.7614 16 17 13.7614 17 11V0Z"
          fill="currentColor"
        />
        <path
          d="M9.35493 11.6942L11.1083 12.8822L13.6758 9.00007"
          stroke="var(--icon-color)"
          strokeWidth="0.822792"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  Instagram: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        data-t="1662533942954"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="3415"
        width="48"
        height="48"
      >
        <path
          d="M512.005172 402.985374c-60.444444 0-109.443879 48.999434-109.443879 109.443879 0 60.449616 48.999434 109.450343 109.443879 109.450343 60.449616 0 109.449051-49.000727 109.44905-109.450343 0-60.444444-48.999434-109.443879-109.44905-109.443879z m438.231919-108.126384a288.21204 288.21204 0 0 0-18.535434-99.737859 176.523636 176.523636 0 0 0-102.383192-102.383192 288.144808 288.144808 0 0 0-99.743031-18.535434C672.646465 71.111111 655.878465 71.111111 512.005172 71.111111c-143.868121 0-160.636121 0-217.570263 3.091394a288.116364 288.116364 0 0 0-99.737858 18.535434 176.508121 176.508121 0 0 0-102.383192 102.383192 288.090505 288.090505 0 0 0-18.535435 99.737859C70.68703 351.793131 70.68703 368.561131 70.68703 512.429253c0 143.874586 0 160.641293 3.091394 217.571555a302.710949 302.710949 0 0 0 18.535435 100.181333 173.866667 173.866667 0 0 0 40.155798 61.782627 171.724283 171.724283 0 0 0 62.227394 40.162262 288.236606 288.236606 0 0 0 99.737858 18.535435c56.934141 3.090101 73.702141 3.090101 217.570263 3.090101 143.873293 0 160.641293 0 217.570262-3.090101a288.265051 288.265051 0 0 0 99.743031-18.535435 171.660929 171.660929 0 0 0 62.222222-40.162262 173.879596 173.879596 0 0 0 40.16097-61.782627 291.351273 291.351273 0 0 0 18.535434-100.181333c3.091394-56.930263 3.091394-73.69697 3.091394-217.571555 0-143.868121 0-160.636121-3.091394-217.570263z m-112.095677 353.05503a252.796121 252.796121 0 0 1-17.211475 79.440162 170.325333 170.325333 0 0 1-94.001131 93.999838 252.886626 252.886626 0 0 1-79.878465 15.449212H376.965172a252.902141 252.902141 0 0 1-79.879758-15.449212 154.801131 154.801131 0 0 1-57.81204-37.955232 154.863192 154.863192 0 0 1-36.19297-56.044606 242.428121 242.428121 0 0 1-15.004444-79.878465V377.389253a242.421657 242.421657 0 0 1 15.004444-79.878465 154.936889 154.936889 0 0 1 37.955232-57.813333 158.476929 158.476929 0 0 1 56.049778-36.191677 252.933172 252.933172 0 0 1 79.879758-15.445334h270.085171a252.918949 252.918949 0 0 1 79.878465 15.445334 155.015758 155.015758 0 0 1 57.813333 37.953939 154.908444 154.908444 0 0 1 36.187798 56.051071 252.894384 252.894384 0 0 1 15.449213 79.878465v135.04c0 90.914909 3.086222 100.182626 1.762262 135.046464v0.438303z m-70.610747-328.338101a105.011717 105.011717 0 0 0-62.227394-62.227394 176.530101 176.530101 0 0 0-60.899556-9.707313h-264.791919a176.579232 176.579232 0 0 0-60.904727 11.470869 105.024646 105.024646 0 0 0-62.222223 60.019071 188.457374 188.457374 0 0 0-9.267717 60.904727v264.793212c0.434424 20.792889 4.313212 41.373737 11.469576 60.898263a105.031111 105.031111 0 0 0 62.227394 62.227393 188.463838 188.463838 0 0 0 58.697697 11.474748h264.791919a176.403394 176.403394 0 0 0 60.899556-11.474748 105.00396 105.00396 0 0 0 62.227394-62.227393c7.389091-19.463758 11.273051-40.080808 11.474747-60.898263V380.035879c0.015515-20.838141-3.878788-41.495273-11.474747-60.904727v0.444767zM512.005172 681.015596a168.142869 168.142869 0 0 1-168.141576-168.586343c0-68.221414 41.121616-129.722182 104.171313-155.792809 63.05099-26.065455 135.59596-11.560081 183.778263 36.742465 48.177131 48.30901 62.489859 120.894061 36.257616 183.873939s-87.837737 103.939879-156.065616 103.762748z m176.530101-304.071111c-20.207192-2.135919-35.54004-19.176727-35.540041-39.495111 0-20.317091 15.332848-37.363071 35.540041-39.49899 20.20202 2.135919 35.536162 19.181899 35.536161 39.49899 0 20.318384-15.334141 37.359192-35.536161 39.495111z m0 0"
          p-id="3416"
        ></path>
      </svg>
    );
  },
  Agent: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        data-t="1663232579673"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1999"
        width="1em"
        height="1em"
      >
        <path
          d="M517.461333 31.957333a218.752 218.752 0 0 1 115.626667 35.584c59.349333 38.058667 99.882667 100.736 118.613333 168.021334 4.48 16.128 7.765333 32.597333 9.856 49.237333 11.008 87.424-10.709333 180.352-66.346666 249.642667-10.282667 12.842667-21.76 24.576-34.133334 35.456l-0.256 0.213333-9.216 20.138667 90.752 23.04c5.845333 0 11.690667-0.042667 17.536 0.128a244.821333 244.821333 0 0 1 63.189334 10.965333 235.818667 235.818667 0 0 1 102.229333 65.578667c12.714667 13.994667 23.509333 29.44 32.682667 45.952 16.213333 30.506667 31.957333 61.269333 47.957333 91.904a115.2 115.2 0 0 1 12.416 44.672c0.682667 10.709333-0.213333 21.504-2.56 31.957333a113.237333 113.237333 0 0 1-60.842667 76.458667 113.706667 113.706667 0 0 1-45.184 11.093333c-264.021333 4.309333-528.085333 0.085333-792.149333 0.085333a112.64 112.64 0 0 1-72.490667-26.709333 113.28 113.28 0 0 1-39.68-89.301333 113.024 113.024 0 0 1 11.050667-45.226667c16-31.914667 32.725333-63.445333 49.493333-94.933333a235.477333 235.477333 0 0 1 150.272-115.84 241.706667 241.706667 0 0 1 55.893334-6.784h14.72l87.381333-22.186667-11.562667-25.216a291.797333 291.797333 0 0 1-17.450666-17.28 302.592 302.592 0 0 1-36.138667-48.938667 322.474667 322.474667 0 0 1-34.901333-86.144c-24.234667-97.450667-5.674667-207.317333 56.874666-287.061333 12.032-15.36 25.685333-29.525333 40.789334-41.941333a237.184 237.184 0 0 1 63.104-37.418667 219.050667 219.050667 0 0 1 75.861333-15.146667h6.613333z m60.032 899.2c110.08-0.298667 220.16-1.322667 330.197334-3.114666 6.784-0.341333 13.354667-1.834667 19.456-4.778667 17.109333-8.234667 27.989333-26.24 27.392-45.184a50.773333 50.773333 0 0 0-4.736-19.498667c-15.530667-30.933333-31.786667-61.525333-48.042667-92.117333a177.92 177.92 0 0 0-23.765333-33.408 171.861333 171.861333 0 0 0-117.376-55.552c-7.424-0.384-14.848-0.213333-22.272-0.213333l-2.645334-0.128c-2.645333-0.341333-2.602667-0.341333-5.205333-0.853334l-115.541333-29.354666a132.864 132.864 0 0 1-27.818667 20.778666l-48.554667 97.066667 38.912 166.357333z m-141.141333-264.490666l-0.426667-0.213334a138.752 138.752 0 0 1-24.704-18.688l-112.426666 28.544c-2.602667 0.512-2.602667 0.512-5.248 0.853334-9.045333 0.384-18.133333 0-27.221334 0.213333a171.605333 171.605333 0 0 0-144.085333 89.088c-16.256 30.592-32.512 61.184-48.042667 92.117333a50.773333 50.773333 0 0 0-4.736 19.498667c-0.597333 18.944 10.325333 36.949333 27.392 45.184 6.101333 2.944 12.672 4.437333 19.456 4.778667 110.037333 1.792 220.117333 2.816 330.197334 3.114666l38.912-166.357333-49.066667-98.133333z m149.12-85.802667l20.181333-43.989333c1.194667-2.304 1.408-2.901333 2.858667-5.034667 1.493333-2.133333 2.005333-2.517333 3.754667-4.437333 3.797333-3.413333 7.808-6.613333 11.605333-10.069334 7.68-7.168 14.848-14.805333 21.418667-22.954666a248.192 248.192 0 0 0 45.354666-90.965334c16.554667-61.482667 12.16-129.322667-13.866666-187.562666-20.565333-45.994667-55.765333-87.338667-102.741334-107.477334a153.728 153.728 0 0 0-55.253333-12.373333l-6.954667-0.042667a153.642667 153.642667 0 0 0-55.424 11.52c-48.042667 19.754667-83.968 61.696-104.874666 108.373334-26.24 58.709333-30.506667 127.232-13.44 189.098666A245.76 245.76 0 0 0 388.266667 500.650667c6.698667 7.722667 13.952 14.848 21.674666 21.546666l2.432 2.346667c0.725333 0.896 1.493333 1.706667 2.176 2.602667 1.834667 2.432 2.090667 3.2 3.498667 5.888l22.4 48.810666 1.408 1.664c1.962667 2.474667 3.413333 5.248 5.077333 7.850667 1.194667 1.792 2.474667 3.456 3.797334 5.12 26.794667 30.805333 77.610667 34.816 110.677333 11.946667 5.632-3.925333 10.752-8.661333 14.933333-14.122667 2.389333-3.157333 4.181333-6.613333 6.314667-9.941333 0.896-1.237333 1.834667-2.389333 2.816-3.498667z"
          p-id="2000"
          fill="#0088cc"
        ></path>
      </svg>
    );
  },
  TabIconMy: ({ className, style }: IconProps) => {
    return (
      <svg
        data-t="1663834841149"
        className={classNames(className, styles.icon)}
        style={style}
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2560"
        width="48"
        height="48"
      >
        <path
          d="M593.024 499.2c102.4-34.176 174.976-130.176 174.976-243.2C768 115.2 652.8 0 512 0S256 115.2 256 256c0 113.024 72.576 209.024 174.976 243.2-181.376 36.224-345.6 189.824-345.6 375.424 0 83.2 66.176 149.376 149.376 149.376h554.624c83.2 0 149.376-66.176 149.376-149.376-0.128-185.6-164.352-339.2-345.728-375.424z"
          p-id="2561"
        ></path>
      </svg>
    );
  },
  TopWallet: ({ className, style, bgColor = "#FB2020" }: IconProps) => {
    return (
      <svg
        width="50"
        height="35"
        className={classNames(className)}
        style={style}
        viewBox="0 0 50 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1212 0H45C47.7614 0 50 2.23858 50 5V30C50 32.7614 47.7614 35 45 35H0L12.1212 0Z"
          fill={bgColor}
        />
        <path
          d="M39.9889 24.9865C39.9889 25.2652 39.9413 25.5255 39.8459 25.7675C39.7506 26.0095 39.6149 26.2222 39.4389 26.4055C39.2629 26.5889 39.0576 26.7319 38.8229 26.8345C38.5883 26.9372 38.3316 26.9885 38.0529 26.9885H22.0809C21.8023 26.9885 21.5383 26.9372 21.2889 26.8345C21.0396 26.7319 20.8196 26.5889 20.6289 26.4055C20.4383 26.2222 20.2879 26.0095 20.1779 25.7675C20.0679 25.5255 20.0129 25.2652 20.0129 24.9865V14.0085C20.0129 13.4512 20.2073 12.9782 20.5959 12.5895C20.9846 12.2009 21.4576 12.0065 22.0149 12.0065H37.9869C38.5443 12.0065 39.0173 12.2009 39.4059 12.5895C39.7946 12.9782 39.9889 13.4512 39.9889 14.0085V17.0005H34.9949C34.4376 17.0005 33.9646 17.1912 33.5759 17.5725C33.1873 17.9539 32.9929 18.4232 32.9929 18.9805C33.0076 19.3619 33.0883 19.6992 33.2349 19.9925C33.3523 20.2419 33.5466 20.4692 33.8179 20.6745C34.0893 20.8799 34.4816 20.9825 34.9949 20.9825H39.9889V24.9865ZM36.9969 10.9945H27.0089C27.8009 10.5839 28.5489 10.1879 29.2529 9.80654C29.8689 9.48387 30.4776 9.16121 31.0789 8.83854C31.6803 8.51587 32.1496 8.26654 32.4869 8.09054C33.0003 7.81187 33.4586 7.68354 33.8619 7.70554C34.2653 7.72754 34.6063 7.79721 34.8849 7.91454C35.2076 8.07587 35.4863 8.28854 35.7209 8.55254L36.9969 10.9945ZM34.0049 18.9805C34.0049 18.7019 34.1003 18.4672 34.2909 18.2765C34.4816 18.0859 34.7163 17.9905 34.9949 17.9905C35.2736 17.9905 35.5083 18.0859 35.6989 18.2765C35.8896 18.4672 35.9849 18.7019 35.9849 18.9805C35.9849 19.2592 35.8896 19.4975 35.6989 19.6955C35.5083 19.8935 35.2736 19.9925 34.9949 19.9925C34.7163 19.9925 34.4816 19.8935 34.2909 19.6955C34.1003 19.4975 34.0049 19.2592 34.0049 18.9805Z"
          fill="white"
        />
      </svg>
    );
  },
  Infinity: ({ className, style }: IconProps) => {
    return (
      <svg
        data-t="1663900005319"
        className={classNames(className, styles.icon)}
        style={style}
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1977"
        width="48"
        height="48"
      >
        <path
          d="M372.622222 746.666667c-105.244444 0-192-86.755556-192-192s86.755556-192 192-192c36.977778 0 72.533333 9.955556 103.822222 29.866666 12.8 8.533333 17.066667 25.6 8.533334 39.822223-8.533333 12.8-25.6 17.066667-39.822222 8.533333-21.333333-14.222222-46.933333-21.333333-72.533334-21.333333-73.955556 0-135.111111 61.155556-135.111111 135.111111s61.155556 135.111111 135.111111 135.111111 135.111111-61.155556 135.111111-135.111111c0-15.644444 12.8-28.444444 28.444445-28.444445s28.444444 12.8 28.444444 28.444445c0 105.244444-86.755556 192-192 192z"
          fill="#FFFFFF"
          p-id="1978"
        ></path>
        <path
          d="M699.733333 746.666667c-39.822222 0-78.222222-11.377778-109.511111-34.133334-12.8-8.533333-15.644444-27.022222-7.111111-39.822222 8.533333-12.8 27.022222-15.644444 39.822222-7.111111 22.755556 15.644444 49.777778 24.177778 76.8 24.177778 73.955556 0 135.111111-61.155556 135.111111-135.111111s-61.155556-135.111111-135.111111-135.111111-135.111111 61.155556-135.111111 135.111111c0 15.644444-12.8 28.444444-28.444444 28.444444s-28.444444-12.8-28.444445-28.444444c0-105.244444 86.755556-192 192-192s192 85.333333 192 192c0 105.244444-86.755556 192-192 192z"
          fill="#FFFFFF"
          p-id="1979"
        ></path>
      </svg>
    );
  },
  Chrome: () => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3421_14784)">
          <path
            d="M4.0355 6.977L1.746 3.0115C3.212 1.176 5.4685 0 8 0C10.9285 0 13.489 1.574 14.8835 3.922H8.3555C8.2385 3.9115 8.12 3.9065 8 3.9065C6.0955 3.9065 4.491 5.213 4.0355 6.977ZM10.864 5.078H15.4495C15.805 5.9835 16 6.969 16 8C16 12.388 12.467 15.95 8.091 15.999L11.3625 10.332C11.823 9.67 12.094 8.866 12.094 8C12.094 6.8565 11.6225 5.8215 10.864 5.078ZM5.094 8C5.094 6.3975 6.3975 5.094 8 5.094C9.6025 5.094 10.9065 6.3975 10.9065 8C10.9065 9.6025 9.6025 10.9065 8 10.9065C6.3975 10.9065 5.094 9.6025 5.094 8ZM9.0965 11.9445L6.8065 15.9115C2.9545 15.335 0 12.0125 0 8C0 6.5745 0.373 5.237 1.0265 4.0775L4.2925 9.735C4.947 11.127 6.3625 12.094 8 12.094C8.3795 12.094 8.7475 12.0415 9.0965 11.9445Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_3421_14784">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  Users: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(className)}
        style={style}
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.6 7.80156C4.92375 7.80156 6 6.72531 6 5.40156C6 4.07781 4.92375 3.00156 3.6 3.00156C2.27625 3.00156 1.2 4.07781 1.2 5.40156C1.2 6.72531 2.27625 7.80156 3.6 7.80156ZM20.4 7.80156C21.7238 7.80156 22.8 6.72531 22.8 5.40156C22.8 4.07781 21.7238 3.00156 20.4 3.00156C19.0763 3.00156 18 4.07781 18 5.40156C18 6.72531 19.0763 7.80156 20.4 7.80156ZM21.6 9.00156H19.2C18.54 9.00156 17.9438 9.26781 17.5088 9.69906C19.02 10.5278 20.0925 12.0241 20.325 13.8016H22.8C23.4638 13.8016 24 13.2653 24 12.6016V11.4016C24 10.0778 22.9238 9.00156 21.6 9.00156ZM12 9.00156C14.3213 9.00156 16.2 7.12281 16.2 4.80156C16.2 2.48031 14.3213 0.601562 12 0.601562C9.67875 0.601562 7.8 2.48031 7.8 4.80156C7.8 7.12281 9.67875 9.00156 12 9.00156ZM14.88 10.2016H14.5688C13.7888 10.5766 12.9225 10.8016 12 10.8016C11.0775 10.8016 10.215 10.5766 9.43125 10.2016H9.12C6.735 10.2016 4.8 12.1366 4.8 14.5216V15.6016C4.8 16.5953 5.60625 17.4016 6.6 17.4016H17.4C18.3938 17.4016 19.2 16.5953 19.2 15.6016V14.5216C19.2 12.1366 17.265 10.2016 14.88 10.2016ZM6.49125 9.69906C6.05625 9.26781 5.46 9.00156 4.8 9.00156H2.4C1.07625 9.00156 0 10.0778 0 11.4016V12.6016C0 13.2653 0.53625 13.8016 1.2 13.8016H3.67125C3.9075 12.0241 4.98 10.5278 6.49125 9.69906Z"
          fill="#98ACD0"
        />
      </svg>
    );
  },
  Trophy: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(className)}
        style={style}
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.0312 2.2271L18.097 1.64858C18.1185 1.46889 18.0984 1.28706 18.0381 1.11496C17.9777 0.942862 17.8785 0.784363 17.7468 0.649806C17.6151 0.515249 17.4539 0.407659 17.2738 0.334057C17.0937 0.260455 16.8986 0.222496 16.7014 0.222657H5.19922C4.79033 0.222657 4.40811 0.377472 4.14144 0.654509C3.87478 0.923398 3.75033 1.29006 3.79478 1.64858L3.86233 2.23769C2.97673 2.26471 2.13712 2.60571 1.52033 3.18889C0.903539 3.77206 0.557707 4.55189 0.555664 5.36414V5.56784C0.555664 8.02043 2.43122 10.1577 4.98233 10.7476C5.80633 13.091 8.15566 14.7508 10.9503 14.7508C13.8748 14.7508 16.1103 12.9761 16.8952 10.7957C19.5201 10.2449 21.4446 8.07421 21.4446 5.56784V5.36414C21.4439 4.53375 21.0843 3.73744 20.4446 3.1495C19.8049 2.56157 18.9371 2.2299 18.0312 2.2271ZM2.33344 5.56784V5.36414C2.33344 4.53303 3.07122 3.85673 3.97789 3.85673H4.03566L4.58678 8.90695C3.24544 8.28769 2.33344 7.00029 2.33344 5.56784ZM13.2703 6.11377L12.7281 6.59451C12.5948 6.71673 12.5414 6.88784 12.5681 7.05895L12.6926 7.73525C12.7548 8.05303 12.5059 8.31377 12.1948 8.33821C12.0881 8.35451 11.9814 8.33821 11.8748 8.28118L11.2081 7.9634C11.0481 7.88192 10.8526 7.88192 10.6837 7.9634L10.017 8.28118C9.92387 8.32685 9.81857 8.34753 9.7132 8.34085C9.60783 8.33416 9.50665 8.30038 9.42127 8.24339C9.33589 8.18639 9.26977 8.10848 9.23049 8.0186C9.19122 7.92872 9.18038 7.83052 9.19922 7.73525L9.25255 7.45821L9.32366 7.05895C9.34063 6.97545 9.33491 6.88939 9.30701 6.80839C9.27911 6.72739 9.22987 6.65394 9.16366 6.59451L8.62144 6.11377C8.29255 5.81229 8.47033 5.29895 8.93255 5.23377L9.67922 5.13599C9.86589 5.11155 10.0259 5.00562 10.1059 4.8508L10.4348 4.23155C10.6481 3.84043 11.2526 3.84043 11.4481 4.23155L11.7859 4.8508C11.8659 5.00562 12.0259 5.11155 12.2126 5.13599L12.9592 5.23377C13.4214 5.29895 13.6081 5.81229 13.2703 6.11377ZM19.6668 5.56784C19.664 6.27982 19.4404 6.9764 19.0221 7.57629C18.6037 8.17618 18.0079 8.65464 17.3041 8.95584L17.8588 3.85673H18.0223C18.929 3.85673 19.6668 4.53303 19.6668 5.36414V5.56784ZM17.0508 19.7782C17.2865 19.7782 17.5126 19.6924 17.6793 19.5396C17.846 19.3868 17.9397 19.1795 17.9397 18.9634C17.9397 18.7473 17.846 18.54 17.6793 18.3872C17.5126 18.2344 17.2865 18.1486 17.0508 18.1486H15.0659C14.5352 17.3786 13.9983 16.8164 13.6792 15.9404C12.7654 16.2199 12.0126 16.3804 10.9503 16.3804C10.0261 16.3818 9.10873 16.2357 8.23922 15.9486C8.23033 15.9486 8.23033 15.9486 8.22144 15.9404C8.06144 16.356 7.84811 16.7471 7.57255 17.1219L6.82589 18.1486H4.84366C4.60792 18.1486 4.38182 18.2344 4.21512 18.3872C4.04843 18.54 3.95478 18.7473 3.95478 18.9634C3.95478 19.1795 4.04843 19.3868 4.21512 19.5396C4.38182 19.6924 4.60792 19.7782 4.84366 19.7782H17.0508Z"
          fill="#98ACD0"
        />
      </svg>
    );
  },
  Sound_on: (props: IconProps) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3342"
            width="1em"
            height="1em"
          >
            <path
              d="M128 420.576v200.864h149.12l175.456 140.064V284.288l-169.792 136.288H128z m132.256-64l204.288-163.968a32 32 0 0 1 52.032 24.96v610.432a32 32 0 0 1-51.968 24.992l-209.92-167.552H96a32 32 0 0 1-32-32v-264.864a32 32 0 0 1 32-32h164.256zM670.784 720.128a32 32 0 0 1-44.832-45.664 214.08 214.08 0 0 0 64.32-153.312 213.92 213.92 0 0 0-55.776-144.448 32 32 0 1 1 47.36-43.04 277.92 277.92 0 0 1 72.416 187.488 278.08 278.08 0 0 1-83.488 198.976zM822.912 858.88a32 32 0 1 1-45.888-44.608A419.008 419.008 0 0 0 896 521.152c0-108.704-41.376-210.848-114.432-288.384a32 32 0 0 1 46.592-43.872c84.16 89.28 131.84 207.04 131.84 332.256 0 127.84-49.76 247.904-137.088 337.728z"
              p-id="3343"
              fill="currentColor"
            ></path>
          </svg>
        )}
      />
    );
  },
  Sound_off: (props: IconProps) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg
            data-t="1666256033082"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3644"
            width="1em"
            height="1em"
          >
            <path
              d="M257.493333 322.4l215.573334-133.056c24.981333-15.413333 57.877333-7.914667 73.493333 16.746667 5.301333 8.373333 8.106667 18.048 8.106667 27.914666v555.989334C554.666667 819.093333 530.784 842.666667 501.333333 842.666667c-9.994667 0-19.786667-2.773333-28.266666-8L257.493333 701.6H160c-41.237333 0-74.666667-33.013333-74.666667-73.738667V396.138667c0-40.725333 33.429333-73.738667 74.666667-73.738667h97.493333z m26.133334 58.4a32.298667 32.298667 0 0 1-16.96 4.8H160c-5.888 0-10.666667 4.714667-10.666667 10.538667v231.733333c0 5.813333 4.778667 10.538667 10.666667 10.538667h106.666667c5.994667 0 11.872 1.664 16.96 4.8L490.666667 770.986667V253.013333L283.626667 380.8zM832.565333 518.4l86.474667 86.474667a30.570667 30.570667 0 1 1-43.232 43.242666L789.333333 561.653333l-86.474666 86.474667a30.570667 30.570667 0 1 1-43.232-43.242667l86.474666-86.474666-86.474666-86.474667a30.570667 30.570667 0 1 1 43.232-43.232L789.333333 475.178667l86.474667-86.474667a30.570667 30.570667 0 1 1 43.232 43.232l-86.474667 86.474667z"
              p-id="3645"
              fill="currentColor"
            ></path>
          </svg>
        )}
      />
    );
  },
  Facebook: (props: IconProps) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3877"
            width="1em"
            height="1em"
          >
            <path
              d="M512.262115 959.556658c247.175132 0 447.569968-200.366167 447.569968-447.556658 0-247.16387-200.394836-447.556658-447.569968-447.556658-247.17718 0-447.556658 200.392788-447.556658 447.556658-0.001024 247.190491 200.378454 447.556658 447.556658 447.556658"
              fill="rgba(30,110,230,.986)"
              p-id="3878"
            ></path>
            <path
              d="M404.292383 436.216104h46.269378v-44.969044c0-19.828563 0.499656-50.408946 14.904699-69.347753 15.172957-20.05689 36.000832-33.690947 71.826579-33.690946 58.371702 0 82.952117 8.326235 82.952118 8.326235l-11.564785 68.550147s-19.285904-5.576079-37.275569-5.57608c-17.99888 0-34.111763 6.449454-34.111764 24.438095v52.269346h73.791416l-5.152191 66.958004h-68.639225v232.604221h-86.731278V503.174108h-46.269378v-66.958004z"
              fill="#FFFFFF"
              p-id="3879"
            ></path>
          </svg>
        )}
      />
    );
  },
  // Withdrawl_l:()=>{
  // 	return <svg width="31" height="11" viewBox="0 0 31 11" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  // 		<rect width="31" height="11" fill="url(#pattern0)"/>
  // 		<defs>
  // 			<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
  // 				<use xlink:href="#image0_3568_14888" transform="scale(0.016129 0.0454545)"/>
  // 			</pattern>
  // 			<image id="image0_3568_14888" width="62" height="22" xlink:href="data:image/png;base64,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"/>
  // 		</defs>
  // 	</svg>;
  // },
  Withdrawl_r: () => {
    return (
      <svg
        width="10"
        height="15"
        viewBox="0 0 10 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.18567 7.49755L1.73043 0L0.438109 1.29913L6.60529 7.50061L0.4375 13.7009L1.72982 15L9.1875 7.50429L9.18445 7.50061L9.18567 7.49755Z"
          fill="#BBBBBB"
        />
      </svg>
    );
  },
  BankCard: () => {
    return (
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.216 4.48678C20.216 3.99077 20.2 3.63077 20.168 3.40678C20.136 3.18279 20.072 2.99878 19.976 2.85478C19.864 2.61478 19.688 2.43879 19.448 2.32678C19.304 2.23078 19.12 2.16677 18.896 2.13478C18.672 2.10279 18.312 2.08678 17.816 2.08678H4.18399C3.68798 2.08678 3.32798 2.10279 3.10399 2.13478C2.87999 2.16677 2.69599 2.23078 2.55199 2.32678C2.31199 2.43879 2.13599 2.61478 2.02399 2.85478C1.92799 2.99878 1.86398 3.18279 1.83199 3.40678C1.79999 3.63077 1.78399 3.99077 1.78399 4.48678V13.5108C1.78399 14.0068 1.79999 14.3668 1.83199 14.5908C1.86398 14.8148 1.92799 14.9988 2.02399 15.1428C2.13599 15.3828 2.31199 15.5588 2.55199 15.6708C2.69599 15.7668 2.87999 15.8308 3.10399 15.8628C3.32798 15.8948 3.68798 15.9108 4.18399 15.9108H17.816C18.312 15.9108 18.672 15.8948 18.896 15.8628C19.12 15.8308 19.304 15.7668 19.448 15.6708C19.688 15.5588 19.864 15.3828 19.976 15.1428C20.072 14.9988 20.136 14.8148 20.168 14.5908C20.2 14.3668 20.216 14.0068 20.216 13.5108V4.48678ZM21.752 4.48678V13.5108C21.752 14.1828 21.716 14.6868 21.644 15.0228C21.572 15.3588 21.472 15.6388 21.344 15.8628C21.072 16.3748 20.688 16.7668 20.192 17.0388C19.952 17.1668 19.664 17.2668 19.328 17.3388C18.992 17.4108 18.488 17.4468 17.816 17.4468H4.18399C3.51199 17.4468 3.00799 17.4108 2.67199 17.3388C2.33599 17.2668 2.04799 17.1668 1.80799 17.0388C1.31198 16.7668 0.927978 16.3828 0.655986 15.8868C0.527994 15.6468 0.427986 15.3588 0.355986 15.0228C0.283986 14.6868 0.247986 14.1828 0.247986 13.5108V4.48678C0.247986 3.81478 0.283986 3.31078 0.355986 2.97478C0.427986 2.63878 0.527994 2.35078 0.655986 2.11078C0.927978 1.61477 1.31198 1.23077 1.80799 0.958781C2.04799 0.830789 2.33599 0.730781 2.67199 0.658781C3.00799 0.586781 3.51199 0.550781 4.18399 0.550781H17.816C18.488 0.550781 18.992 0.586781 19.328 0.658781C19.664 0.730781 19.944 0.830789 20.168 0.958781C20.68 1.23077 21.072 1.61477 21.344 2.11078C21.472 2.35078 21.572 2.63878 21.644 2.97478C21.716 3.31078 21.752 3.81478 21.752 4.48678ZM0.247986 4.39078H21.752V5.92678H0.247986V4.39078ZM0.247986 7.46278H21.752V8.99878H0.247986V7.46278ZM3.31999 12.0708H9.46399V13.6068H3.31999V12.0708Z"
          fill="#BFBFBF"
        />
      </svg>
    );
  },
  Sport: ({ props }: any) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 12 12"
          >
            <path
              d="M6.609.054a6.01,6.01,0,0,1,5.433,5.433A4.787,4.787,0,0,1,7.955,4.14,4.785,4.785,0,0,1,6.609.054Zm4.736,6.5A5.788,5.788,0,0,1,5.6.048,5.994,5.994,0,0,0,.047,5.608a5.709,5.709,0,0,1,6.44,6.44A5.993,5.993,0,0,0,12.047,6.5a5.8,5.8,0,0,1-.7.047ZM4.159,7.936A4.725,4.725,0,0,0,.054,6.618,6.012,6.012,0,0,0,5.475,12.04a4.723,4.723,0,0,0-1.316-4.1Z"
              fill="currentColor"
              transform="translate(-0.047 -0.048)"
            ></path>
          </svg>
        )}
      />
    );
  },
  Copy: ({ props }: any) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5333 4.66667H8.46662V2.20001C8.4648 1.67607 8.27043 1.17415 7.92588 0.803663C7.58133 0.433179 7.11455 0.22418 6.62728 0.222229H2.03928C1.55202 0.22418 1.08523 0.433179 0.740684 0.803663C0.396135 1.17415 0.201766 1.67607 0.199951 2.20001V7.13334C0.201766 7.65728 0.396135 8.1592 0.740684 8.52968C1.08523 8.90017 1.55202 9.10917 2.03928 9.11112H4.33328V11.3333C4.33328 11.9227 4.55102 12.4879 4.9386 12.9047C5.32617 13.3214 5.85184 13.5556 6.39995 13.5556H10.5333C11.0814 13.5556 11.6071 13.3214 11.9946 12.9047C12.3822 12.4879 12.6 11.9227 12.6 11.3333V6.8889C12.6 6.29953 12.3822 5.73429 11.9946 5.31755C11.6071 4.9008 11.0814 4.66667 10.5333 4.66667V4.66667ZM4.33328 6.8889V7.62964H2.03928C1.97867 7.62964 1.91865 7.6168 1.86265 7.59186C1.80666 7.56692 1.75577 7.53036 1.71292 7.48427C1.67006 7.43819 1.63606 7.38348 1.61286 7.32326C1.58967 7.26305 1.57773 7.19852 1.57773 7.13334V2.20001C1.57773 2.06838 1.62636 1.94215 1.71292 1.84907C1.79947 1.756 1.91687 1.70371 2.03928 1.70371H6.62728C6.7497 1.70371 6.86709 1.756 6.95365 1.84907C7.04021 1.94215 7.08884 2.06838 7.08884 2.20001V4.66667H6.39995C5.85184 4.66667 5.32617 4.9008 4.9386 5.31755C4.55102 5.73429 4.33328 6.29953 4.33328 6.8889V6.8889Z"
              fill="currentColor"
            />
          </svg>
        )}
      />
    );
  },
  Notifications: () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9383 3.35391C13.9383 2.325 13.0758 1.48594 12.0117 1.48594C10.95 1.48594 10.0852 2.32266 10.0852 3.35391C10.0852 3.45938 10.0945 3.5625 10.1109 3.66328C7.45078 4.56094 5.26641 7.32188 5.26641 10.5867V13.1555C5.26641 13.1555 5.26641 16.8563 4.32891 16.8891C3.76875 16.8891 3.33984 17.3063 3.33984 17.8219C3.33984 18.3398 3.77109 18.7547 4.30313 18.7547H19.7203C20.2547 18.7547 20.6836 18.3375 20.6836 17.8219C20.6836 17.3016 20.2523 16.8891 19.7203 16.8891C18.757 16.8891 18.757 13.1813 18.757 13.1813V10.5844C18.757 7.31719 16.7156 4.55625 13.9125 3.6586C13.9289 3.56016 13.9383 3.45703 13.9383 3.35391V3.35391ZM14.9016 19.6852C14.8992 21.2344 13.6172 22.4859 12.0117 22.4859C10.418 22.4859 9.12422 21.2367 9.12188 19.6852"
          fill="#495A71"
        />
      </svg>
    );
  },
  Deposit: () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.75153 11.9976C6.75153 14.2791 8.6022 16.1297 10.8837 16.1297C13.1652 16.1297 15.0159 14.2791 15.0159 11.9976C15.0159 9.71604 13.1652 7.86536 10.8837 7.86536C8.6022 7.86536 6.75153 9.71604 6.75153 11.9976ZM11.246 9.52509C11.246 9.77479 11.246 9.77479 11.4957 9.81396C11.6867 9.84333 11.8678 9.90208 12.049 9.98042C12.1469 10.0245 12.1811 10.093 12.1518 10.1958C12.1077 10.3476 12.0636 10.5043 12.0147 10.6561C11.9706 10.798 11.9217 10.8225 11.7846 10.754C11.5055 10.6218 11.2166 10.563 10.9082 10.5826C10.8299 10.5875 10.7515 10.5973 10.6732 10.6316C10.4088 10.7491 10.3647 11.0379 10.59 11.2191C10.7026 11.3121 10.8348 11.3758 10.967 11.4345C11.202 11.5324 11.437 11.6255 11.6573 11.7479C12.3672 12.1395 12.5581 13.0306 12.0588 13.6377C11.8776 13.858 11.6426 14.0049 11.3684 14.0783C11.2509 14.1126 11.1971 14.1714 11.202 14.2987C11.2069 14.4211 11.202 14.5435 11.202 14.6659C11.202 14.7736 11.1481 14.8323 11.0404 14.8372C10.9082 14.8421 10.776 14.8421 10.6487 14.8372C10.5312 14.8372 10.4774 14.7687 10.4774 14.6561C10.4774 14.5679 10.4774 14.4798 10.4774 14.3868C10.4774 14.1909 10.4676 14.1812 10.2815 14.1518C10.0416 14.1126 9.80171 14.0588 9.58139 13.951C9.40514 13.8678 9.39045 13.8237 9.43941 13.6426C9.47858 13.5055 9.51285 13.3733 9.55691 13.2362C9.60587 13.0796 9.64994 13.06 9.79192 13.1334C10.0367 13.2607 10.2962 13.3342 10.5704 13.3684C10.7466 13.388 10.918 13.3733 11.0796 13.2999C11.3831 13.1677 11.4321 12.8152 11.1726 12.6047C11.0845 12.5312 10.9865 12.4774 10.8837 12.4333C10.6193 12.3158 10.3403 12.2277 10.0857 12.0759C9.67931 11.8311 9.41983 11.4982 9.4492 10.9988C9.48348 10.4357 9.80171 10.0881 10.3158 9.90208C10.5263 9.82375 10.5312 9.82864 10.5312 9.60833C10.5312 9.53489 10.5312 9.45655 10.5312 9.38311C10.5361 9.21665 10.5655 9.18727 10.7319 9.18238C10.7858 9.18238 10.8348 9.18238 10.8886 9.18238C11.2411 9.16769 11.2411 9.16769 11.246 9.52509ZM18.0367 11.9976C18.0367 12.6291 17.5226 13.1432 16.8911 13.1432C16.2595 13.1432 15.7454 12.6291 15.7454 11.9976C15.7454 11.366 16.2595 10.8519 16.8911 10.8519C17.5226 10.8519 18.0367 11.366 18.0367 11.9976ZM4.87148 10.8519C5.50306 10.8519 6.01714 11.366 6.01714 11.9976C6.01714 12.6291 5.50306 13.1432 4.87148 13.1432C4.2399 13.1432 3.72583 12.6291 3.72583 11.9976C3.72583 11.366 4.2399 10.8519 4.87148 10.8519ZM0 16.8495V7.14566C0 6.10771 0.847001 5.26071 1.88494 5.26071H19.8776C20.9155 5.26071 21.7625 6.10771 21.7625 7.14566V13.0942H20.1518V9.18238C20 9.22154 19.8433 9.24113 19.6818 9.24113C18.6291 9.24113 17.7723 8.38433 17.7723 7.3317C17.7723 7.17014 17.7919 7.01347 17.8311 6.86659H3.82375C3.84333 6.97919 3.85802 7.0967 3.85802 7.2191C3.85802 8.27173 3.00122 9.12852 1.94859 9.12852C1.83599 9.12852 1.72338 9.11873 1.61567 9.09915V14.896C1.72338 14.8764 1.83599 14.8666 1.94859 14.8666C3.00122 14.8666 3.85802 15.7234 3.85802 16.776C3.85802 16.8984 3.84822 17.011 3.82375 17.1285H15.011V18.7393H1.88984C0.847001 18.7344 0 17.8874 0 16.8495ZM21.5226 17.3831C21.6548 17.3831 21.7625 17.4908 21.7625 17.623V18.4945C21.7625 18.6267 21.6548 18.7344 21.5226 18.7344H15.7454C15.6132 18.7344 15.5055 18.6267 15.5055 18.4945V17.623C15.5055 17.4908 15.6132 17.3831 15.7454 17.3831H21.5226ZM22.6438 16.8397H16.8666C16.7344 16.8397 16.6267 16.7319 16.6267 16.5998V15.7283C16.6267 15.5961 16.7344 15.4884 16.8666 15.4884H22.6438C22.776 15.4884 22.8837 15.5961 22.8837 15.7283V16.5998C22.8837 16.7319 22.776 16.8397 22.6438 16.8397ZM24 13.8335V14.705C24 14.8372 23.8923 14.9449 23.7601 14.9449H17.9829C17.8507 14.9449 17.743 14.8372 17.743 14.705V13.8335C17.743 13.7013 17.8507 13.5936 17.9829 13.5936H23.7601C23.8923 13.5936 24 13.7013 24 13.8335Z"
          fill="#495A71"
        />
      </svg>
    );
  },
  Withdrawa: () => {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4468_15452)">
          <path
            d="M20.6204 3.87714L17.2989 0.555629C16.5581 -0.18521 15.3561 -0.18521 14.6152 0.555629L11.2937 3.87714H20.6204Z"
            fill="#495A71"
          />
          <path
            d="M12.6724 0.766598H7.9085C6.85856 0.766598 6.00488 1.62028 6.00488 2.6653V3.87714H9.55699L12.6724 0.766598Z"
            fill="#495A71"
          />
          <path
            d="M13.1287 23.3303H17.7356C18.7463 23.3303 19.5705 22.5061 19.5705 21.4954V20.259H16.2L13.1287 23.3303Z"
            fill="#495A71"
          />
          <path
            d="M5.0874 20.2541L8.29607 23.4628C9.01238 24.1791 10.1752 24.1791 10.8915 23.4628L14.1001 20.2541H5.0874V20.2541Z"
            fill="#495A71"
          />
          <path
            d="M13.0061 7.90515C10.7099 7.90515 8.84558 9.76951 8.84558 12.0656C8.84558 14.3617 10.7099 16.2261 13.0061 16.2261C15.3022 16.2261 17.1665 14.3617 17.1665 12.0656C17.1665 9.76951 15.3022 7.90515 13.0061 7.90515ZM14.1983 13.7092C14.0167 13.93 13.7812 14.0772 13.5065 14.1557C13.3838 14.19 13.3348 14.2538 13.3397 14.3765C13.3446 14.4991 13.3397 14.6218 13.3397 14.7444C13.3397 14.8524 13.2857 14.9112 13.1778 14.9161C13.0453 14.921 12.9128 14.921 12.7804 14.9161C12.6626 14.9161 12.6087 14.8474 12.6087 14.7346C12.6087 14.6463 12.6087 14.5531 12.6037 14.4648C12.6037 14.2685 12.5939 14.2587 12.4026 14.2293C12.1573 14.19 11.9218 14.136 11.6961 14.0281C11.5195 13.9447 11.5048 13.9005 11.5538 13.7141C11.5931 13.5767 11.6274 13.4394 11.6716 13.3069C11.7206 13.1499 11.7648 13.1303 11.9071 13.2039C12.1524 13.3314 12.4173 13.405 12.6921 13.4394C12.8687 13.4639 13.0404 13.4443 13.2072 13.3707C13.5114 13.2382 13.5605 12.8801 13.3004 12.6691C13.2121 12.5955 13.114 12.5415 13.0061 12.4974C12.7362 12.3796 12.4566 12.2913 12.2063 12.1392C11.7942 11.8939 11.5342 11.5554 11.5636 11.0549C11.598 10.4907 11.9169 10.1375 12.4369 9.94614C12.6528 9.86764 12.6528 9.87254 12.6528 9.64686C12.6528 9.57326 12.6528 9.49476 12.6528 9.42117C12.6577 9.25436 12.6872 9.22492 12.854 9.22001C12.9079 9.22001 12.957 9.22001 13.011 9.22001C13.3691 9.22001 13.3691 9.22001 13.3691 9.57817C13.3691 9.83329 13.3691 9.83329 13.6242 9.87254C13.8156 9.90198 14.002 9.96085 14.1786 10.0394C14.2768 10.0835 14.316 10.1522 14.2817 10.2552C14.2375 10.4073 14.1934 10.5643 14.1443 10.7164C14.0952 10.8587 14.0511 10.8832 13.9137 10.8145C13.6341 10.6772 13.3397 10.6232 13.0355 10.6379C12.9521 10.6428 12.8736 10.6526 12.8 10.687C12.5351 10.8047 12.4909 11.0991 12.7166 11.2806C12.8294 11.3738 12.9619 11.4376 13.0993 11.4965C13.3348 11.5946 13.5703 11.6878 13.796 11.8105C14.5073 12.203 14.7036 13.0959 14.1983 13.7092Z"
            fill="#495A71"
          />
          <path
            d="M19.0554 13.4295C19.6922 13.4295 20.2084 12.9134 20.2084 12.2766C20.2084 11.6398 19.6922 11.1236 19.0554 11.1236C18.4187 11.1236 17.9025 11.6398 17.9025 12.2766C17.9025 12.9134 18.4187 13.4295 19.0554 13.4295Z"
            fill="#495A71"
          />
          <path
            d="M6.95179 13.4295C7.58855 13.4295 8.10475 12.9134 8.10475 12.2766C8.10475 11.6398 7.58855 11.1236 6.95179 11.1236C6.31503 11.1236 5.79883 11.6398 5.79883 12.2766C5.79883 12.9134 6.31503 13.4295 6.95179 13.4295Z"
            fill="#495A71"
          />
          <path
            d="M21.9304 5.28032H3.81668C2.77165 5.28032 1.91797 6.134 1.91797 7.17903V16.9522C1.91797 17.9972 2.77165 18.8509 3.81668 18.8509H21.9353C22.9804 18.8509 23.8341 17.9972 23.8341 16.9522V7.17903C23.8291 6.134 22.9804 5.28032 21.9304 5.28032ZM22.21 15.132C22.058 15.0928 21.901 15.0731 21.7341 15.0731C20.6744 15.0731 19.8109 15.9317 19.8109 16.9964C19.8109 17.0749 19.8158 17.1583 19.8256 17.2368H5.7644C5.78402 17.1239 5.79874 17.0062 5.79874 16.8835C5.79874 15.8238 4.94015 14.9603 3.8755 14.9603C3.75775 14.9603 3.64982 14.9701 3.53697 14.9897V9.15133C3.64491 9.17095 3.75775 9.18076 3.8755 9.18076C4.93524 9.18076 5.79874 8.32218 5.79874 7.25753C5.79874 7.13487 5.78893 7.01712 5.7644 6.90428H19.8698C19.8305 7.05637 19.8109 7.21337 19.8109 7.37527C19.8109 8.43502 20.6695 9.29851 21.7341 9.29851C21.896 9.29851 22.058 9.27889 22.21 9.23964V15.132Z"
            fill="#495A71"
          />
        </g>
        <defs>
          <clipPath id="clip0_4468_15452">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.875977)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  VIPLevel: () => {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4468_15517)">
          <path
            d="M10.9014 8.54403L9.11102 13.6588L7.32021 8.54403H6.03223L8.4686 15.3368L8.51182 15.456H9.7098L12.105 8.78483L12.1906 8.54403H10.9014Z"
            fill="#495A71"
          />
          <path
            d="M13.9554 8.54403H12.6898V15.4556H13.9554V8.54403Z"
            fill="#495A71"
          />
          <path
            d="M19.4557 9.716C19.3165 9.45359 19.1197 9.23079 18.8714 9.05398C18.629 8.88237 18.3405 8.75239 18.0146 8.66797C17.697 8.58598 17.349 8.54436 16.981 8.54436H15.2174V15.456H16.483V12.8684H16.755C17.157 12.8684 17.5379 12.8184 17.887 12.7196C18.2398 12.6188 18.5514 12.4724 18.8126 12.2836C19.0786 12.092 19.2906 11.8552 19.4418 11.5792C19.593 11.3008 19.6702 10.9857 19.6702 10.6424C19.6701 10.2936 19.5974 9.98201 19.4557 9.716ZM18.2938 11.108C18.2197 11.2456 18.1122 11.366 17.9737 11.4648C17.831 11.5668 17.6586 11.6448 17.4606 11.698C17.2566 11.7532 17.0289 11.7808 16.7842 11.7808H16.4829V9.63157H16.9517C17.1601 9.63157 17.3605 9.65197 17.5481 9.69237C17.7249 9.72917 17.8797 9.79039 18.0097 9.87359C18.1329 9.95398 18.2313 10.0552 18.3005 10.1764C18.3697 10.2964 18.4049 10.4496 18.4049 10.6324C18.4049 10.8112 18.3674 10.9712 18.2938 11.108Z"
            fill="#495A71"
          />
          <path
            d="M24.5166 11.1516L21.705 8.33998V4.36359C21.705 3.70077 21.1678 3.16359 20.505 3.16359H16.5282L13.7166 0.35203C13.4913 0.126421 13.1862 4.673e-05 12.8678 4.673e-05C12.5493 4.673e-05 12.2442 0.126468 12.0194 0.351655L9.20777 3.16321H5.231C4.56819 3.16321 4.031 3.7004 4.031 4.36321V8.33961L1.21939 11.1512C0.750599 11.62 0.750599 12.3796 1.21939 12.8484L4.031 15.66V19.6364C4.031 20.2992 4.56819 20.8364 5.231 20.8364H9.20777L12.0194 23.648C12.2442 23.8736 12.5494 24 12.8678 24C13.1861 24 13.4913 23.8736 13.7162 23.6484L16.5278 20.8368H20.5045C21.1673 20.8368 21.7045 20.2996 21.7045 19.6368V15.6604L24.5161 12.8488C24.9849 12.38 24.9849 11.62 24.5166 11.1516ZM20.5045 15.1632V19.6368H16.0309L12.8678 22.8L9.70455 19.6368H5.231V15.1632L2.06778 12L5.231 8.83681V4.36321H9.7046L12.8678 1.20004L16.031 4.36326H20.5046V8.83686L23.6678 12.0001L20.5045 15.1632Z"
            fill="#495A71"
          />
          <path
            d="M12.8678 4.20004C13.1992 4.20004 13.4678 3.93141 13.4678 3.60004C13.4678 3.26867 13.1992 3.00004 12.8678 3.00004C12.5365 3.00004 12.2678 3.26867 12.2678 3.60004C12.2678 3.93141 12.5365 4.20004 12.8678 4.20004Z"
            fill="#495A71"
          />
          <path
            d="M12.8678 21C13.1992 21 13.4678 20.7314 13.4678 20.4C13.4678 20.0686 13.1992 19.8 12.8678 19.8C12.5365 19.8 12.2678 20.0686 12.2678 20.4C12.2678 20.7314 12.5365 21 12.8678 21Z"
            fill="#495A71"
          />
          <path
            d="M6.92776 6.66003C7.25913 6.66003 7.52776 6.39141 7.52776 6.06004C7.52776 5.72867 7.25913 5.46004 6.92776 5.46004C6.59639 5.46004 6.32776 5.72867 6.32776 6.06004C6.32776 6.39141 6.59639 6.66003 6.92776 6.66003Z"
            fill="#495A71"
          />
          <path
            d="M18.8074 18.5396C19.1388 18.5396 19.4074 18.271 19.4074 17.9396C19.4074 17.6082 19.1388 17.3396 18.8074 17.3396C18.476 17.3396 18.2074 17.6082 18.2074 17.9396C18.2074 18.271 18.476 18.5396 18.8074 18.5396Z"
            fill="#495A71"
          />
          <path
            d="M18.8074 6.66003C19.1388 6.66003 19.4074 6.39141 19.4074 6.06004C19.4074 5.72867 19.1388 5.46004 18.8074 5.46004C18.476 5.46004 18.2074 5.72867 18.2074 6.06004C18.2074 6.39141 18.476 6.66003 18.8074 6.66003Z"
            fill="#495A71"
          />
          <path
            d="M6.92776 18.5396C7.25913 18.5396 7.52776 18.271 7.52776 17.9396C7.52776 17.6082 7.25913 17.3396 6.92776 17.3396C6.59639 17.3396 6.32776 17.6082 6.32776 17.9396C6.32776 18.271 6.59639 18.5396 6.92776 18.5396Z"
            fill="#495A71"
          />
          <path
            d="M21.2677 12.6C21.5991 12.6 21.8677 12.3314 21.8677 12C21.8677 11.6687 21.5991 11.4 21.2677 11.4C20.9364 11.4 20.6677 11.6687 20.6677 12C20.6677 12.3314 20.9364 12.6 21.2677 12.6Z"
            fill="#495A71"
          />
          <path
            d="M4.4678 12.6C4.79917 12.6 5.0678 12.3314 5.0678 12C5.0678 11.6687 4.79917 11.4 4.4678 11.4C4.13643 11.4 3.8678 11.6687 3.8678 12C3.8678 12.3314 4.13643 12.6 4.4678 12.6Z"
            fill="#495A71"
          />
        </g>
        <defs>
          <clipPath id="clip0_4468_15517">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.867798)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
  Account: () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.2 22.4H4.79995C3.91995 22.4 3.19995 21.68 3.19995 20.8C3.19995 17.68 5.67995 15.2 8.79995 15.2H15.2C18.32 15.2 20.8 17.68 20.8 20.8C20.8 21.68 20.08 22.4 19.2 22.4Z"
          fill="#495A71"
          stroke="#495A71"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12C14.6509 12 16.8 9.85097 16.8 7.2C16.8 4.54903 14.6509 2.4 12 2.4C9.34898 2.4 7.19995 4.54903 7.19995 7.2C7.19995 9.85097 9.34898 12 12 12Z"
          fill="#495A71"
          stroke="#495A71"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  Records: () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4468_15566)">
          <path
            d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM17.1733 17.1707C14.3176 20.0264 9.68761 20.0264 6.83189 17.1707C5.40961 15.7485 4.6957 13.8861 4.69012 12.0219C4.68825 11.3913 5.1915 10.8632 5.82211 10.8575C6.45797 10.8517 6.97528 11.3655 6.97528 12H6.97763C6.97763 13.2874 7.46766 14.5748 8.44777 15.5549C10.4079 17.5151 13.5973 17.5151 15.5575 15.5549C17.5256 13.5869 17.5256 10.4132 15.5575 8.44514C13.5973 6.48497 10.4079 6.48502 8.44777 8.44514C8.79309 8.79047 8.61422 9.38138 8.1353 9.47714L6.1155 9.88111C5.68763 9.9667 5.31037 9.58945 5.39597 9.16158L5.79994 7.14178C5.8957 6.66286 6.48661 6.48398 6.83194 6.82931C9.68766 3.97359 14.3176 3.97359 17.1734 6.82931C20.022 9.67795 20.022 14.322 17.1733 17.1707ZM14.3091 12.3421C14.7189 12.5788 14.8594 13.1029 14.6227 13.5128C14.3861 13.9226 13.862 14.0631 13.4521 13.8264L11.5741 12.7421L11.5741 12.742C11.3181 12.5939 11.1456 12.3172 11.1456 12V8.97455C11.1456 8.5013 11.5293 8.11762 12.0025 8.11762C12.4758 8.11762 12.8595 8.5013 12.8595 8.97455V11.5053L14.3091 12.3421Z"
            fill="#495A71"
          />
        </g>
        <defs>
          <clipPath id="clip0_4468_15566">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  Updated: ({ props }: any) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.46667 14.9333C3.36 14.9333 0 11.5733 0 7.46667C0 3.36 3.36 0 7.46667 0C9.62667 0 11.68 0.933333 13.0933 2.56C13.2267 2.72 13.2267 2.98667 13.0667 3.12C12.9067 3.25333 12.64 3.25333 12.5067 3.09333C11.2267 1.62667 9.38667 0.8 7.46667 0.8C3.78667 0.8 0.8 3.78667 0.8 7.46667C0.8 11.1467 3.78667 14.1333 7.46667 14.1333C10.0533 14.1333 12.4267 12.6133 13.52 10.2667C13.6 10.0533 13.84 9.97333 14.0533 10.08C14.2667 10.16 14.3467 10.4 14.24 10.6133C13.0133 13.2267 10.3733 14.9333 7.46667 14.9333Z"
              fill="#FBFBFB"
            />
            <path
              d="M13.0933 3.46495H10.6667C10.4533 3.46495 10.2667 3.27828 10.2667 3.06495C10.2667 2.85161 10.4533 2.66495 10.6667 2.66495H12.6933V0.638281C12.6933 0.424948 12.88 0.238281 13.0933 0.238281C13.3067 0.238281 13.4933 0.424948 13.4933 0.638281V3.06495C13.4933 3.30495 13.3067 3.46495 13.0933 3.46495Z"
              fill="#FBFBFB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.80794 10.1218C4.10281 9.41671 3.70667 8.46034 3.70667 7.46313C3.70667 6.46591 4.10281 5.50954 4.80794 4.8044C5.51308 4.09927 6.46945 3.70312 7.46667 3.70312C8.46388 3.70312 9.42025 4.09927 10.1254 4.8044C10.8305 5.50954 11.2267 6.46591 11.2267 7.46313C11.2267 8.46034 10.8305 9.41671 10.1254 10.1218C9.42025 10.827 8.46388 11.2231 7.46667 11.2231C6.46945 11.2231 5.51308 10.827 4.80794 10.1218ZM6.90667 8.76984H9.12C9.33333 8.76984 9.52 8.60984 9.52 8.39651C9.52 8.18318 9.33333 7.99651 9.12 7.99651H7.30667V5.48984C7.30667 5.27651 7.12 5.08984 6.90667 5.08984C6.69333 5.08984 6.50667 5.27651 6.50667 5.48984V8.36984C6.50667 8.58318 6.69333 8.76984 6.90667 8.76984Z"
              fill="white"
            />
          </svg>
        )}
      />
    );
  },
  Reload: () => {
    return (
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7039 11.0324C18.3866 10.883 18.2419 10.6824 18.2699 10.4304C18.2979 10.1784 18.4053 9.97771 18.5919 9.82838C18.6479 9.79104 18.8299 9.64637 19.1379 9.39437C19.4459 9.14237 19.8239 8.83904 20.2719 8.48438C19.4879 7.58837 18.5546 6.88371 17.4719 6.37038C16.3893 5.85704 15.2133 5.60037 13.9439 5.60037C12.7679 5.60037 11.6666 5.81971 10.6399 6.25837C9.61328 6.69704 8.71728 7.29904 7.95195 8.06437C7.18662 8.82971 6.58462 9.72571 6.14595 10.7524C5.70728 11.779 5.48795 12.8804 5.48795 14.0564C5.48795 15.2137 5.70728 16.3057 6.14595 17.3324C6.58462 18.359 7.18662 19.255 7.95195 20.0204C8.71728 20.7857 9.61328 21.3877 10.6399 21.8264C11.6666 22.265 12.7679 22.4844 13.9439 22.4844C14.9146 22.4844 15.8339 22.3304 16.7019 22.0224C17.5699 21.7144 18.3633 21.2804 19.0819 20.7204C19.8006 20.1604 20.4166 19.5024 20.9299 18.7464C21.4433 17.9904 21.8213 17.1644 22.0639 16.2684C22.1946 15.839 22.4373 15.4844 22.7919 15.2044C23.1466 14.9244 23.5666 14.7844 24.0519 14.7844C24.6306 14.7844 25.1206 14.9897 25.5219 15.4004C25.9233 15.811 26.1239 16.2964 26.1239 16.8564C26.1239 17.1177 26.0773 17.3697 25.9839 17.6124C25.5919 18.919 25.0133 20.123 24.2479 21.2244C23.4826 22.3257 22.5726 23.273 21.5179 24.0664C20.4633 24.8597 19.2919 25.4804 18.0039 25.9284C16.7159 26.3764 15.3626 26.6004 13.9439 26.6004C12.2079 26.6004 10.5746 26.2737 9.04395 25.6204C7.51328 24.967 6.18328 24.071 5.05395 22.9324C3.92462 21.7937 3.02861 20.4637 2.36595 18.9424C1.70328 17.421 1.37195 15.7924 1.37195 14.0564C1.37195 12.3204 1.70328 10.687 2.36595 9.15637C3.02861 7.62571 3.92462 6.29571 5.05395 5.16637C6.18328 4.03704 7.51328 3.14104 9.04395 2.47838C10.5746 1.81571 12.2079 1.48437 13.9439 1.48438C15.8666 1.48438 17.6493 1.88104 19.2919 2.67438C20.9346 3.46771 22.3346 4.54571 23.4919 5.90837C23.9213 5.59104 24.2806 5.31571 24.5699 5.08237C24.8593 4.84904 25.0413 4.70437 25.1159 4.64837C25.2279 4.55504 25.3493 4.48504 25.4799 4.43837C25.6106 4.39171 25.7319 4.39171 25.8439 4.43837C25.9559 4.48504 26.0539 4.58304 26.1379 4.73237C26.2219 4.88171 26.2826 5.10571 26.3199 5.40438C26.3386 5.57238 26.3573 5.85704 26.3759 6.25837C26.3946 6.65971 26.4133 7.12637 26.4319 7.65837C26.4506 8.19037 26.4599 8.74104 26.4599 9.31038C26.4599 9.87971 26.4506 10.4164 26.4319 10.9204C26.4133 11.555 26.2639 12.0124 25.9839 12.2924C25.8346 12.4417 25.6106 12.5257 25.3119 12.5444C25.0133 12.563 24.6959 12.535 24.3599 12.4604C23.8559 12.3484 23.3006 12.227 22.6939 12.0964C22.0873 11.9657 21.5086 11.8304 20.9579 11.6904C20.4073 11.5504 19.9219 11.4197 19.5019 11.2984C19.0819 11.177 18.8159 11.0884 18.7039 11.0324Z"
          fill="white"
        />
      </svg>
    );
  },
  Google: () => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="5648"
        width="1em"
        height="1em"
      >
        <path
          d="M214.101333 512c0-32.512 5.546667-63.701333 15.36-92.928L57.173333 290.218667A491.861333 491.861333 0 0 0 4.693333 512c0 79.701333 18.858667 154.88 52.394667 221.610667l172.202667-129.066667A290.56 290.56 0 0 1 214.101333 512"
          fill="#FBBC05"
          p-id="5649"
        ></path>
        <path
          d="M516.693333 216.192c72.106667 0 137.258667 25.002667 188.458667 65.962667L854.101333 136.533333C763.349333 59.178667 646.997333 11.392 516.693333 11.392c-202.325333 0-376.234667 113.28-459.52 278.826667l172.373334 128.853333c39.68-118.016 152.832-202.88 287.146666-202.88"
          fill="#EA4335"
          p-id="5650"
        ></path>
        <path
          d="M516.693333 807.808c-134.357333 0-247.509333-84.864-287.232-202.88l-172.288 128.853333c83.242667 165.546667 257.152 278.826667 459.52 278.826667 124.842667 0 244.053333-43.392 333.568-124.757333l-163.584-123.818667c-46.122667 28.458667-104.234667 43.776-170.026666 43.776"
          fill="#34A853"
          p-id="5651"
        ></path>
        <path
          d="M1005.397333 512c0-29.568-4.693333-61.44-11.648-91.008H516.650667V614.4h274.602666c-13.696 65.962667-51.072 116.650667-104.533333 149.632l163.541333 123.818667c93.994667-85.418667 155.136-212.650667 155.136-375.850667"
          fill="#4285F4"
          p-id="5652"
        ></path>
      </svg>
    );
  },
  CheckCircle: () => {
    return (
      <svg
        viewBox="64 64 896 896"
        focusable="false"
        data-icon="check-circle"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path>
      </svg>
    );
  },
  Cross: () => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="11"
          cy="11"
          r="10.3125"
          stroke="#0E131B"
          strokeWidth="1.375"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0444 15.0438C15.3128 14.7753 15.3128 14.34 15.0444 14.0715L11.9194 10.9465L15.1 7.7658C15.3685 7.49732 15.3685 7.06201 15.1 6.79353C14.8315 6.52504 14.3962 6.52504 14.1277 6.79353L10.9471 9.9742L7.59028 6.6174C7.32179 6.34891 6.88649 6.34891 6.61801 6.6174C6.34952 6.88588 6.34952 7.32118 6.61801 7.58967L9.97481 10.9465L6.67367 14.2476C6.40518 14.5161 6.40518 14.9514 6.67367 15.2199C6.94215 15.4884 7.37745 15.4884 7.64594 15.2199L10.9471 11.9187L14.0721 15.0438C14.3406 15.3122 14.7759 15.3122 15.0444 15.0438Z"
          fill="#0E131B"
        />
      </svg>
    );
  },
  Crypto: ({ props }: any) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg width="1em" height="1em" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd">
              <circle cx="16" cy="16" r="16" fill="#F7931A" />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M23.189 14.02c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84-1.728-.43-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.596 6l-.708 2.839c-.376-.086-.746-.17-1.104-.26l.002-.009-2.384-.595-.46 1.846s1.283.294 1.256.312c.7.175.826.638.805 1.006l-.806 3.235c.048.012.11.03.18.057l-.183-.045-1.13 4.532c-.086.212-.303.531-.793.41.018.025-1.256-.313-1.256-.313l-.858 1.978 2.25.561c.418.105.828.215 1.231.318l-.715 2.872 1.727.43.708-2.84c.472.127.93.245 1.378.357l-.706 2.828 1.728.43.715-2.866c2.948.558 5.164.333 6.097-2.333.752-2.146-.037-3.385-1.588-4.192 1.13-.26 1.98-1.003 2.207-2.538zm-3.95 5.538c-.533 2.147-4.148.986-5.32.695l.95-3.805c1.172.293 4.929.872 4.37 3.11zm.535-5.569c-.487 1.953-3.495.96-4.47.717l.86-3.45c.975.243 4.118.696 3.61 2.733z"
              />
            </g>
          </svg>
        )}
      />
    );
  },
  UsersV2: ({ props }: any) => {
    return (
      <Icon
        {...props}
        component={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 43 28"
            fill="currentColor"
          >
            <path
              d="M12.9286 14C17.0105 14 20.3143 10.8687 20.3143 7C20.3143 3.13125 17.0105 0 12.9286 0C8.84663 0 5.54284 3.13125 5.54284 7C5.54284 10.8687 8.84663 14 12.9286 14ZM17.993 16H17.4457C16.0741 16.625 14.5508 17 12.9286 17C11.3063 17 9.78963 16.625 8.4114 16H7.86407C3.67004 16 0.267334 19.225 0.267334 23.2V25C0.267334 26.6562 1.68513 28 3.43264 28H22.4245C24.172 28 25.5898 26.6562 25.5898 25V23.2C25.5898 19.225 22.1871 16 17.993 16ZM31.9204 14C35.4154 14 38.251 11.3125 38.251 8C38.251 4.6875 35.4154 2 31.9204 2C28.4254 2 25.5898 4.6875 25.5898 8C25.5898 11.3125 28.4254 14 31.9204 14ZM35.0857 16H34.8351C33.9185 16.3 32.9491 16.5 31.9204 16.5C30.8917 16.5 29.9223 16.3 29.0057 16H28.7551C27.4098 16 26.1701 16.3687 25.082 16.9625C26.691 18.6062 27.7 20.7875 27.7 23.2V25.6C27.7 25.7375 27.667 25.8687 27.6604 26H39.3061C41.0536 26 42.4714 24.6562 42.4714 23C42.4714 19.1313 39.1676 16 35.0857 16Z"
              fill="currentColor"
            />
          </svg>
        )}
      />
    );
  },
  Bomb: () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 36 36"
        fill="none"
      >
        <path
          d="M30.9804 6.2242L27.3232 9.88136L29.1869 11.7451C29.848 12.4062 29.848 13.4752 29.1869 14.1293L27.9632 15.353C28.7931 17.1887 29.2573 19.2282 29.2573 21.3733C29.2573 29.4542 22.7096 36.0019 14.6286 36.0019C6.54772 36.0019 0 29.4612 0 21.3803C0 13.2994 6.54772 6.75168 14.6286 6.75168C16.7737 6.75168 18.8133 7.21586 20.6489 8.04575L21.8726 6.82201C22.5337 6.16091 23.6027 6.16091 24.2568 6.82201L26.1206 8.68575L29.7777 5.02859L30.9804 6.2242ZM35.165 4.2198H33.4771C33.0129 4.2198 32.6331 4.59958 32.6331 5.06376C32.6331 5.52794 33.0129 5.90772 33.4771 5.90772H35.165C35.6292 5.90772 36.009 5.52794 36.009 5.06376C36.009 4.59958 35.6292 4.2198 35.165 4.2198ZM30.9452 0C30.481 0 30.1012 0.379782 30.1012 0.84396V2.53188C30.1012 2.99606 30.481 3.37584 30.9452 3.37584C31.4094 3.37584 31.7892 2.99606 31.7892 2.53188V0.84396C31.7892 0.379782 31.4094 0 30.9452 0ZM33.3294 3.86815L34.525 2.67254C34.8555 2.34199 34.8555 1.80748 34.525 1.47693C34.1944 1.14638 33.6599 1.14638 33.3294 1.47693L32.1338 2.67254C31.8032 3.00309 31.8032 3.5376 32.1338 3.86815C32.4714 4.1987 33.0059 4.1987 33.3294 3.86815ZM28.561 3.86815C28.8916 4.1987 29.4261 4.1987 29.7566 3.86815C30.0872 3.5376 30.0872 3.00309 29.7566 2.67254L28.561 1.47693C28.2305 1.14638 27.696 1.14638 27.3654 1.47693C27.0349 1.80748 27.0349 2.34199 27.3654 2.67254L28.561 3.86815ZM33.3294 6.25937C32.9988 5.92882 32.4643 5.92882 32.1338 6.25937C31.8032 6.58992 31.8032 7.12443 32.1338 7.45498L33.3294 8.65059C33.6599 8.98114 34.1944 8.98114 34.525 8.65059C34.8555 8.32004 34.8555 7.78553 34.525 7.45498L33.3294 6.25937ZM7.87696 19.1298C7.87696 16.6471 9.89543 14.6286 12.3781 14.6286C12.997 14.6286 13.5034 14.1223 13.5034 13.5034C13.5034 12.8845 12.997 12.3781 12.3781 12.3781C8.65762 12.3781 5.6264 15.4093 5.6264 19.1298C5.6264 19.7487 6.13278 20.255 6.75168 20.255C7.37058 20.255 7.87696 19.7487 7.87696 19.1298Z"
          fill="#E5EC99"
        />
      </svg>
    );
  },
  Devices: () => {
    return (
      <Icon
        component={() => (
          <svg
            height="1em"
            viewBox="0 -960 960 960"
            width="1em"
            fill="currentColor"
          >
            <path d="M80-160v-120h80v-440q0-33 23.5-56.5T240-800h600v80H240v440h240v120H80Zm520 0q-17 0-28.5-11.5T560-200v-400q0-17 11.5-28.5T600-640h240q17 0 28.5 11.5T880-600v400q0 17-11.5 28.5T840-160H600Zm40-120h160v-280H640v280Zm0 0h160-160Z" />
          </svg>
        )}
      />
    );
  },
  Music: () => {
    return (
      <Icon
        component={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <g fill="none">
              <circle
                cx="6"
                cy="18"
                r="3"
                fill="currentColor"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <circle
                cx="18"
                cy="17"
                r="3"
                fill="currentColor"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path fill="currentColor" d="M21 3L9 6v4l12-3V3z" />
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 18v-8m12 7V7M9 10V6l12-3v4M9 10l12-3"
              />
            </g>
          </svg>
        )}
      />
    );
  },
  Volume: () => {
    return (
      <Icon
        component={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <g fill="none">
              <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
              <path
                fill="currentColor"
                d="M13.26 3.3a1.1 1.1 0 0 1 1.734.78l.006.114v15.612a1.1 1.1 0 0 1-1.643.957l-.096-.062L6.68 16H4a2 2 0 0 1-1.995-1.85L2 14v-4a2 2 0 0 1 1.85-1.995L4 8h2.68l6.58-4.7Zm6.407 3.483A6.985 6.985 0 0 1 22 12a6.985 6.985 0 0 1-2.333 5.217a1 1 0 1 1-1.334-1.49A4.985 4.985 0 0 0 20 12c0-1.48-.642-2.81-1.667-3.727a1 1 0 1 1 1.334-1.49Zm-2 2.236A3.992 3.992 0 0 1 19 11.999a3.991 3.991 0 0 1-1.333 2.982a1 1 0 0 1-1.422-1.4l.088-.09c.41-.368.667-.899.667-1.491a1.99 1.99 0 0 0-.548-1.376l-.119-.115a1 1 0 1 1 1.334-1.49Z"
              />
            </g>
          </svg>
        )}
      />
    );
  },
  VolumeMuted: () => {
    return (
      <Icon
        component={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <g fill="none">
              <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z" />
              <path
                fill="currentColor"
                d="M13.26 3.3a1.1 1.1 0 0 1 1.734.78l.006.114v15.612a1.1 1.1 0 0 1-1.643.957l-.096-.062L6.68 16H4a2 2 0 0 1-1.995-1.85L2 14v-4a2 2 0 0 1 1.85-1.994L4 8h2.68l6.58-4.7Zm4.326 5.872L19 10.586l1.414-1.414a1 1 0 1 1 1.414 1.414L20.414 12l1.414 1.414a1 1 0 0 1-1.414 1.415L19 13.414l-1.414 1.415a1 1 0 0 1-1.414-1.415L17.586 12l-1.414-1.414a1 1 0 1 1 1.414-1.414Z"
              />
            </g>
          </svg>
        )}
      />
    );
  },
  Shuffle: () => {
    return (
      <Icon
        component={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m18 20l3-3m0 0l-3-3m3 3h-4a5 5 0 0 1-5-5a5 5 0 0 0-5-5H3m15-3l3 3m0 0l-3 3m3-3h-4a4.978 4.978 0 0 0-3 1M3 17h4a4.978 4.978 0 0 0 3-1"
            />
          </svg>
        )}
      />
    );
  },
  RepeatOne: () => {
    return (
      <Icon
        component={() => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
          >
            <g fill="currentColor">
              <path d="M11 4v1.466a.25.25 0 0 0 .41.192l2.36-1.966a.25.25 0 0 0 0-.384l-2.36-1.966a.25.25 0 0 0-.41.192V3H5a5 5 0 0 0-4.48 7.223a.5.5 0 0 0 .896-.446A4 4 0 0 1 5 4zm4.48 1.777a.5.5 0 0 0-.896.446A4 4 0 0 1 11 12H5.001v-1.466a.25.25 0 0 0-.41-.192l-2.36 1.966a.25.25 0 0 0 0 .384l2.36 1.966a.25.25 0 0 0 .41-.192V13h6a5 5 0 0 0 4.48-7.223Z" />
              <path d="M9 5.5a.5.5 0 0 0-.854-.354l-1.75 1.75a.5.5 0 1 0 .708.708L8 6.707V10.5a.5.5 0 0 0 1 0z" />
            </g>
          </svg>
        )}
      />
    );
  },
  Copy2: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className)}
        style={style}
        width="1em"
        height="1em"
        fill="currentColor"
        viewBox="0 0 23.001 24.3"
      >
        <path
          d="M1.293,23.294A1.294,1.294,0,0,1,0,22V5.175A1.292,1.292,0,0,1,1.293,3.882h15.53a1.292,1.292,0,0,1,1.293,1.293V22a1.293,1.293,0,0,1-1.293,1.3Zm.647-1.941H16.174V5.825H1.94ZM20.056,19.09V1.942H7.441A.972.972,0,0,1,7.441,0H21.029A.978.978,0,0,1,22,.978V19.089a.972.972,0,1,1-1.942,0Z"
          transform="translate(0.5 0.5)"
          strokeMiterlimit="10"
          strokeWidth="1"
        ></path>
      </svg>
    );
  },
  GbDownloadPopupClose: ({ className, style }: IconProps) => {
    return (
      <svg
        className={classNames(styles.icon, className, "a2hs-close")}
        style={style}
        width="20"
        height="20"
        viewBox="0 0 1024 1024"
      >
        <path d="M505.173 416.427L122.88 27.307C95.573 0 54.613 0 20.48 27.307c-27.307 27.306-27.307 68.266 0 102.4L409.6 512 20.48 901.12c-27.307 27.307-27.307 68.267 0 102.4 27.307 27.307 68.267 27.307 102.4 0L512 614.4l389.12 389.12c27.307 27.307 68.267 27.307 102.4 0 27.307-27.307 27.307-68.267 0-102.4L607.573 512l389.12-389.12c27.307-27.307 27.307-68.267 0-102.4-27.306-27.307-68.266-27.307-102.4 0l-389.12 395.947z"></path>
      </svg>
    );
  },
};
